<template v-if="solutionInfo">
  
  <div id="module-CA-detail" @click="handleRootClick" :class="[
    p_solution.type == 0 ? 'CA_A' : 'CA_B',
    printMode === 'excel' ? 'print-excel' : ''
  ]">

<template>
  <!-- 피드백 보기용 caView - body로 텔레포트 -->
  <Teleport to="body">
    <dialog_caView 
      v-if="showViewDialog" 
      :p_solution="selectedSolution" 
      :closeFunction="closeViewDialog" 
    />
  </Teleport>
  
  <!-- 기존 템플릿 내용... -->
</template>

    <!-- 피드백 이력 다이얼로그 추가 -->
    <div class="dialog" v-if="showFeedbackDialog">
      <span class="close" @click="showFeedbackDialog = false"></span>
      <div class="paper feedback-history">
        <div class="header">
          <h1>피드백 이력</h1>
          <span @click="showFeedbackDialog = false">X</span>
        </div>
        
        <div class="feedback-list">
          <div 
            v-for="fb in feedbackList" 
            :key="fb.idx" 
            class="feedback-item"
            :class="{ complete: fb.status === 'complete' }"
          >
            <div class="feedback-meta">
              <span class="status-badge" :class="fb.status"> {{ fb.status === 'complete' ? '완료' : fb.status === 'in_progress' ? '검토중' : '대기중' }} </span>
              <span class="date">{{ fb.requested_at?.slice(0, 10) }}</span>
            </div>
            <div class="feedback-content" v-if="fb.status === 'complete'">
              <p class="reviewer">리뷰어: {{ fb.reviewer_name || fb.reviewer_id }}</p>
              <p class="comment" v-if="fb.comment">{{ fb.comment }}</p>
              <div class="feedback-actions">
                <button 
                  v-if="fb.status === 'complete'" 
                  @click="viewFeedbackAnnotations(fb)"
                  class="fb-action-btn"
                >
                  <i class="ph ph-eye"></i> 피드백 보기
                </button> 
                <button 
                  v-if="fb.comparison_solution_idx" 
                  @click="viewComparisonSolution(fb)"
                  class="fb-action-btn"
                >
                  <i class="ph ph-git-diff"></i> 수정 제안 비교
                </button>
              </div>
            </div>
          </div>
          
          <div v-if="feedbackList.length === 0" class="feedback-empty">
            피드백 이력이 없습니다.
          </div>
        </div>
        
        <div class="btns" v-if="solutionInfo.feedback_status !== 'requested'">
          <button @click="requestFeedback" class="request-btn">
            <i class="ph-bold ph-chat-circle-dots"></i> 피드백 재요청
          </button>
        </div>
      </div>
    </div>
    <!-- #### inc.dialogs ##### end -->

    <!-- #### inc.dialogs ##### start -->
    <dialog_wheelDateChooser @submit="handleDateSubmit" v-if="datePickerShow" :default-date="tempDateForWheel" />
    <dialog_solutionInfoEdit v-if="showSolutionInfoEdit" :onOffFun="editSolutionInfo" :reLoadFunction="reloadSolutionInfo" :solutionId="editingSolutionForInfo.idx" />
    <dialog_ratingView @submit="handleRatingSubmit" v-if="showRatingView" :defaultRate="defRateValue" />
    <dialog_companyPicker @submit="handleCompanySubmit" v-if="showCompanyPicker" />
    <!-- #### inc.dialogs ##### end -->


    <!-- #### MAIN HEADER #### start -->
    <div class="main-header">
      <div>
        <img src='/imgs/LOGO.png'>
        <h2 v-if="solutionInfo.type == 0">보장 스케치(제안)</h2>
        <h2 v-if="solutionInfo.type == 1">보장 스케치(분석)</h2>
      </div>
      <p @click="showAlert()"><i class="ph-bold ph-x"></i></p>
    </div>
    <!-- #### MAIN HEADER #### end -->


    <!-- #### SYSTEM #### start-->
    <div class="system" v-if="system_show">
      <img src="/gif/kickboard_hare.gif" alt="로딩중" />
      <h2>{{system_show_info.title}}</h2>
      <span>{{system_show_info.text}}</span>
    </div>
    <!-- #### SYSTEM #### end -->


    <!-- #### EXIT ALERT #### start-->
    <div class="alert" v-if="alert_show">
      <span class="cls" @click="alert_show = false"></span>
      <div class="paper">
        <h2>스케치를 닫기 전에<br>변경사항을 저장하시겠습니까?</h2>
        <p>저장하지 않는 경우 변경사항은 무효처리 됩니다.</p>
        
        <div class="btns">
          <button @click="exitExecute(1)">저장</button>
          <button @click="exitExecute(0)" class="cancel">닫기</button>
          <!-- <button @click="alert_show.value = false" class="cancel">취소</button> -->
        </div>
      </div>
    </div>
    <!-- #### EXIT ALERT #### end-->


    <!-- #### REFERENCE #### start-->
    <!-- <div class="reference" v-if="showingReference">
      <span class="cls" @click="showingReference = null"></span>
      <div class="paper">
        <img v-if="showingReference == 10" src="https://amadiary.com/data/file/post/rlad17524138993.png">
        <img v-if="showingReference == 20" src="https://amadiary.com/data/file/post/rlad17524138991.png">
        <img v-if="showingReference == 30" src="https://amadiary.com/data/file/post/rlad17524138992.png">
        <img v-if="showingReference == 40" src="https://amadiary.com/data/file/post/rlad17524138990.png">
      </div>
    </div> -->
    <dialog_boardView v-if="showingReference" :thePost="watchingPost" :windowOnOff="openReference" />
    <!-- #### REFERENCE #### end-->


    <!-- #### dialog #### start -->
    <div class="dialog" v-if="dialogOpen">
      
      <span class="close" @click="openDialog(false)"></span>

      <div class="paper edit-plan" v-if="dialogSel == 'edit-plan' && editingPlan">
        
        <div class="suggestion" v-if="show_suggestion" @mousedown.prevent>
          <span v-for="(ex_cov, i) in filteredExCoverages" :key="i" @click.stop="addCoverage(ex_cov.idx)">
            {{ ex_cov.name }}
          </span>
        </div>

        <div class="header"> <h1>플랜 편집</h1> <span @click="openDialog(false)">X</span> </div>
        <div class="item"> <p>플랜 이름</p> <input type="text" v-model="editingPlan.name" /> </div>
        <div class="double">
          <div class="item double">
            <div class="item">
              <p>보험사 *</p>
              <span class="company-name" v-if="editingPlan.company != 'etc'"> {{insuCompanys.find(c => c.value === editingPlan.company)?.name}} </span>
              <input v-if="editingPlan.company == 'etc' || editingPlan.company_etc" type="text" v-model="editingPlan.company_etc">
            </div>
            <button @click="ToggleCompanyPicker(true)">회사 찾기</button>
          </div>
          <div class="item">
            <p>갱신여부 *</p>
            <select v-model="editingPlan.renewable">
              <option value="0">비갱신형</option>
              <option value="1">갱신형</option>
              <option value="2">일부갱신형</option>
              <option value="3">기타(그외)</option>
            </select>
          </div>
        </div>

        <div class="double">
          <div class="item"> <p>상품명</p> <input type="text" v-model="editingPlan.sub_type" /> </div>
          <div class="item" style="max-width: 140px;">
            <p>보험종류 *</p>
            <select v-model="editingPlan.type_id">
              <option value="0">직접입력</option>
              <option value="1">종합보장</option>
              <option value="2">건강/상해</option>
              <option value="3">단독실손</option>
              <option value="4">종신/정기</option>
              <option value="5">연금/저축</option>
              <option value="6">회사/법인</option>
              <option value="7">실버/상속</option>
              <option value="8">자녀/태아</option>
              <option value="9">운전자</option>
              <option value="10">치아보험</option>
              <option value="11">골프/레저</option>
              <option value="12">주택/건물</option>
            </select>
          </div>
          <div v-if="editingPlan.type_id == 0" class="item"> <p>보험종류(직접입력)</p> <input :disabled="editingPlan.type_id != 0"  type="text" v-model="editingPlan.type" /> </div>
        </div>
        <!-- <div class="item"> <p>가입일</p> <input @click="(e) => useDatePicker(true, e)" type="date" v-model="editingPlan.joined_at" readonly /> </div> -->
        <div class="double">
          <div class="item"> <p>납기 *</p> <input type="number" min="0" v-model="editingPlan.pay" /> </div>
          <div class="item">
            <p>납기 유형*</p>
            <select v-model="editingPlan.pay_type">
              <option value="0">년납</option>
              <option value="1">세납</option>
              <option value="2">일시납</option>
            </select>
          </div>
          <div class="item"> <p>만기 *</p> <input type="number" min="0" v-model="editingPlan.end" :disabled="editingPlan.end_type == 2"/> </div>
          <div class="item">
            <p>만기 유형*</p>
            <select v-model="editingPlan.end_type">
              <option value="0">세만기</option>
              <option value="1">년만기</option>
              <option value="2">종신</option>
              <option value="3">기타(그외)</option>
            </select>
          </div>
        </div>
        <div class="double">
          <div class="item"> <p>보험료 *</p> <input type="number" min="0" v-model="editingPlan.price" /> </div>
          <div class="item"> <p>환급금</p> <input type="number" min="0" v-model="editingPlan.return_worth" /> </div>
        </div>
        <div class="item"> <p>보장금액 *</p> <input type="number" min="0" v-model="editingPlan.worth" /> </div>
        <div class="item"> <p>비고</p> <textarea v-model="editingPlan.remarks" placeholder="플랜에 대한 비고를 입력하세요."></textarea> </div>
        <div class="btns">
        <button class="save" @click="openDialog(false)">확인</button>
        </div>
      </div>


      <div class="paper edit-coverage" v-if="dialogSel == 'edit-coverage'">
        <div class="header"> <h1>{{ editingChapterParent.item.name }} 편집</h1> <span @click="openDialog(false)">X</span> </div>

        <div class="cov-editor">
          <template v-for="(chapter, i) in editingChapterParent.item.list" :key="i">
            <div class="mother" v-if="!editingChapter?.item?.idx || chapter.idx === editingChapter.item.idx">
              <h2>
                <span>{{ chapter.name }} </span>
                <span v-if="chapter.show_type == 0">총 {{ formatMoney(returnCoverageTotalValue(editingPlanForCov.fake_idx, chapter)) }} 만원 
                <i @click="changeShowType(chapter)" :class="chapter.show_type ? 'ph ph-list-numbers' : 'ph ph-plus-minus' "></i></span>
                <span v-if="chapter.show_type == 1">총 {{ formatMoney(returnCoverageTotalValue(editingPlanForCov.fake_idx, chapter)) }} 건 
                <i @click="changeShowType(chapter)" :class="chapter.show_type ? 'ph ph-list-numbers' : 'ph ph-plus-minus' "></i></span>
              </h2>
              <ul>
                <template v-for="(coverage, j) in orderedCoverages(editingPlanForCov.fake_idx, chapter.idx).sort((a, b) => a.no - b.no)" :key="j">
                  <li class="coverage">
                    <div class="info">
                      <input type="checkbox" v-model="coverage.use" :true-value="1" :false-value="0" @change="mergePlansCoverages()" v-if="!coverage?.is_union" />
                      <span @click="showEditCovDialog(true ,coverage)" @mouseenter="covMouseHoverSt(coverage)" @mouseleave="covMouseLeaveSt(coverage)"> {{ coverage.name }}</span>
                      <span v-if="coverage.linked_ref" @click="openReference(true, coverage.linked_ref)"><i class="ph ph-question"></i></span>
                      <span class="wide" @click.stop="editCoverageFold(coverage)"> <i :class="coverage.fold ? 'ph ph-caret-up' : 'ph ph-caret-down'" v-if="!coverage.parent"></i> </span>
                      <span @click="showEditCovDialog(true ,coverage)" v-if="coverage?.is_union">{{ formatMoney(getResultFromUnionsChild(coverage)) }}만원</span>
                      <span @click="showEditCovDialog(true ,coverage)" v-else>{{ formatMoney(coverage.value) }}만원</span>
                      <button @click="deleteCoverage(coverage)"><i class="ph ph-x"></i></button>
                      <div id="description-viewer" v-if="coverage?.showDescription && coverage?.description"> <h2>{{ coverage.long_name }}</h2><span v-if="coverage?.description">{{ coverage?.description }}</span> </div>
                    </div>
                    <div class="child-list">
                      <template v-for="(child, i) in getSortedChildren(coverage)" :key="i">
                        <div class="" :style="{ paddingLeft: child._depth * 36 + 'px'  }" v-if="child.visible" @mouseenter="covMouseHoverSt(child)" @mouseleave="covMouseLeaveSt(child)">
                          <input type="checkbox" v-model="child.use" :true-value="1" :false-value="0" @change="mergePlansCoverages()" v-if="!child?.is_union" />
                          <span @click="showEditCovDialog(true ,child)"> {{ child.name }}</span>
                          <span v-if="child.linked_ref" @click="openReference(true, child.linked_ref)"><i class="ph ph-question"></i></span>
                          <span class="wide"></span>
                          <span @click="showEditCovDialog(true ,child)">{{ formatMoney(child.value) }}만원</span>
                          <button @click="deleteCoverage(child)"><i class="ph ph-x"></i></button>
                          <div id="description-viewer" v-if="child?.showDescription && child?.description">
                            <h2>{{ child.long_name }}</h2>
                            <span v-if="child?.description">{{ child?.description }}</span>
                          </div>
                        </div>
                      </template>
                      <div class="add" style="padding-left:36px;" v-if="!coverage.fold">
                        <span v-if="!coverage.showAdd" @click="coverage.showAdd = true; nowNewAddCovTemp = coverage"> <small>여기를 눌러 자식 추가</small> </span>
                        <span v-else @click="coverage.showAdd = false; CoverageNameForAddSub = ''; nowNewAddCovTemp = null;"><i class="ph ph-minus-circle"></i></span>
                        <template v-if="coverage.showAdd">
                          <input type="text" v-model='CoverageNameForAddSub' @keyup.enter="addChildCoverage(coverage, null, CoverageValueForAddSub)" @focus="onSubFocus(coverage)" @blur="onSubBlur(coverage)" placeholder="입력또는 선택"/>
                          <input type="text" v-model='CoverageValueForAddSub' @keyup.enter="addChildCoverage(coverage, null, CoverageValueForAddSub)" @focus="onSubFocus(coverage)" @blur="onSubBlur(coverage)" placeholder="보장금액 (만원)"/>
                          <ul v-if="show_sub_suggestion == coverage.original_idx" class="subSuggestion" @mousedown.prevent>
                            <li @click="CoverageNameForAddSub = cov.name" v-for="(cov, i) in filteredExCoveragesForSub(coverage)" :key="i">{{cov.name}}</li>
                          </ul>
                          <button @click="addChildCoverage(coverage, null, CoverageValueForAddSub)"><i class="ph ph-check"></i></button>
                        </template>
                      </div>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </template>
          
        </div>

        <div class="editing" v-if="dialog_editing_cov">
          <span class="cls" @click="showEditCovDialog(false)"></span>
          <div class="page">

            <div class="header">
              <h2>보장 상세 설정</h2>
              <span @click="showEditCovDialog(false)">X</span>
            </div>

            <div class="concepts-double">
              <div style="flex:2"> <label>보장 이름</label> <input type="text" v-model="editingCoverage.name" @keyup.enter="showEditCovDialog(false)"/> </div>
            </div>

            <div class="concepts-double">
              <div>
                <label>항목분류 (부모)</label>
                <select v-model="tempEdCovSelChap">
                  <option v-for="(chapter, i) in chapterList" :key="i" :value="chapter.name"> {{ chapter.name }} </option>
                </select>
              </div>
              <div>
                <label>항목분류 (선택)</label>
                <select v-model="editingCoverage.chapter_idx">
                  <template v-for="(chapter, i) in getChapterChild()" :key="i">
                    <option v-if="tempEdCovSelChap == getChapterParentByIdx(chapter.idx)" :value="chapter.idx"> {{ chapter.name }} </option>
                  </template>
                </select>
              </div>
            </div>

            <div class="concepts-double">
              <div> <label>보장금액 (단위:만원)</label> <input type="number" v-model="editingCoverage.value"/> <p class="moneySize">만원</p> </div>
              <div> <label>보험료 (단위:만원)</label> <input type="number" v-model="editingCoverage.premium"/> <p class="moneySize">만원</p> </div>
            </div>
            
            <div class="concepts-double">
              <div> <label>갱신 여부</label>
                <select v-model="editingCoverage.renewable">
                <option value="0">비갱신형</option>
                <option value="1">갱신형</option>
              </select> </div> 
              <div>
                <label>보장 기간</label>
                <div style="display:flex; flex-direction:row; gap:12px;">
                  <input style="flex:4;" type="number" v-model="editingCoverage.period_value" />
                  <select style="flex:1;" v-model="editingCoverage.period_type">
                    <option value="세">세</option>
                    <option value="년">년</option>
                    <option value="월">월</option>
                  <option value="일">일</option>
                </select>
                </div>
              </div>
            </div>

            <div class="concepts-double option">
              <div class="forCheck"><input type="checkbox" id="edCovMakeVisible" v-model="editingCoverage.use" :true-value="1" :false-value="0" @change="mergePlansCoverages()" /> <label for="edCovMakeVisible">👀 보이기</label> </div>
              <div class="forCheck"><input type="checkbox" id="edCovMakeCalculable" v-model="editingCoverage.calculable" :true-value="1" :false-value="0" @change="mergePlansCoverages()" /> <label for="edCovMakeCalculable">➕ 합산하기</label> </div>
            </div>
            

            <div class="btns">
              <button @click="showEditCovDialog(false)" style="background:var(--color-brand); color:black;">확인</button>
            </div>
          </div>
        </div>

        <div class="modal" v-if="modal_show">
          <div class="paper">
            <span class="cls" @click="modalOpen(false)"></span>
            <h2>'{{ CoverageNameForAdd }}'<small style="font-size:var(--font-size-base)"><br>일치하는 담보 없음<br><br>AI가 다음 항목을 추천합니다</small></h2>
            <template v-for="chapter in modal_editing_choseChapter" v-bind:key="chapter">
              <button v-if="chapter.delegate" @click="selectChapterToMoveCov(chapter.idx)">{{ chapter.name }}</button>
            </template>
            
            <ul>
              <template v-for="chapter in modal_editing_choseChapter" v-bind:key="chapter">
                <li v-if="!chapter.delegate" @click="selectChapterToMoveCov(chapter.idx)" >{{chapter.name}}</li>
              </template>
            </ul>

            <small style="opacity:0.4;">항목을 선택하지 않으면 삭제됩니다.</small>
          </div>
          
        </div>

        <div class="suggestion" v-if="show_suggestion" @mousedown.prevent>
          <span v-for="(ex_cov, i) in filteredExCoverages" :key="i" @click="setCoverageNameForAdd(ex_cov.name)" :class="{ selected: temp_sel_suggestion == i }" :title="ex_cov.long_name">
            {{ ex_cov.name }}
          </span>
          <span style="text-decoration: underline; cursor: pointer;" @click="showMoreToggle"> {{showMore ? '접기' : '더보기'}}</span>
        </div>

        <div class="foot">
          <div>
            <input
              type="text"
              autocomplete="off"
              placeholder="보장이름"
              id="CoverageNameForAdd"
              v-model="CoverageNameForAdd"
              @focus="onFocus"
              @blur="onBlur"
              @input="updateCovNameForAdd"
              @keydown="suggestionMove"
            />
          </div>
          <div>
            <input type="number" min="0" placeholder="0" v-model="CoverageValueForAdd" @keyup.enter="addCoverage()"/> <span>만원</span>
          </div>
          <button @click="addCoverage()">추가</button>
        </div>

      </div>

      <div class="paper fav-plans" v-if="dialogSel == 'fav-plans'">
        <div class="header"> <h1>플랜 불러오기</h1> <span @click="openDialog(false)">X</span> </div>
        <ul>
          <li v-for="(plan, index) in favPlanList" :key="index" @click="loadFavPlan(plan)">
            <img :src="getInsuCompanyInfo(plan.company).short_img"/>
            <span>{{ plan.name }}</span>
            <span>{{ plan.pay }}년/{{ plan.end }}세</span>
          </li>
        </ul>
      </div>

    </div>
    <!-- #### dialog #### end -->


    <!-- #### HEADER #### start -->
    <div class="header">
      <div class="left" @click="editSolutionInfo(true, solutionInfo)">
        <!-- <div> <span>{{solutionInfo.name}}</span> </div> -->
        <div>
          <span>{{solutionInfo.name}}</span>
        </div>
        <div class="profile">
          <img :src="basic_profile_url" />
          <span>{{ connectedCustomer?.name || solutionInfo.client?.name}}<small>님</small></span>
          <span>({{ genderChoser(connectedCustomer?.rrn?.split('-')[1]?.slice(0,1)) || genderChoser(solutionInfo.client.civ_code?.split('-')[1]?.slice(0,1)) || '미입력'}})</span>
          <span>{{ calculateInsuAge(connectedCustomer?.rrn?.split('-')[0]) + '세' || calculateInsuAge(solutionInfo.client.civ_code?.split('-')[0]) + '세' || '미입력'}} <small>(보험나이)</small></span>
        </div>
        <div> <span>직업등급: {{ connectedCustomer?.job_grade || solutionInfo.client?.grade}}급</span> </div>
        <!-- <div> <span>성향 {{solutionInfo.client.personal}}</span> </div> -->
      </div>
      <div class="right">
        <!-- <button @click="printSolution('card')" class="btn_a" title="카드형 인쇄">
          <i class="ph-bold ph-squares-four"></i> 카드형
        </button> -->
        <div class="print-dropdown-wrap">
          <button @click="showPrintMenu = !showPrintMenu" class="btn_a" title="인쇄">
            <i class="ph-bold ph-printer"></i> 인쇄
          </button>
          <div class="print-dropdown-backdrop" v-if="showPrintMenu" @click="showPrintMenu = false"></div>
          <div class="print-dropdown" v-if="showPrintMenu">
            <button @click="printSolution('excel'); showPrintMenu = false;">
              <i class="ph-bold ph-table"></i> 엑셀 인쇄
            </button>
            <button @click="printSolution('card'); showPrintMenu = false;">
              <i class="ph-bold ph-chart-bar"></i> 차트 인쇄
            </button>
          </div>
        </div>
        <button @click="openFavPlans()" class="btn_a" title="플랜 불러오기">
          <i class="ph-bold ph-folder" style="font-size:var(--font-size-lg)"></i> 불러오기
        </button>
        <button @click="saveSolution" class="btn_a" title="저장">
          <i class="ph-bold ph-floppy-disk" style="font-size:var(--font-size-lg)"></i> 저장
        </button>
        
        <!-- 피드백 버튼 추가 -->
        <button 
          v-if="solutionInfo.feedback_status === 'none'" 
          @click="requestFeedback" 
          class="btn_a btn_feedback"
          title="피드백 요청"
        >
          <i class="ph-bold ph-chat-circle-dots"></i> 피드백 요청
        </button>
        <button 
          v-else-if="solutionInfo.feedback_status === 'requested'" 
          class="btn_a btn_feedback requested"
          disabled
          title="피드백 대기 중"
        >
          <i class="ph ph-hourglass"></i> 피드백 대기중
        </button>
        <button 
          v-else-if="solutionInfo.feedback_status === 'complete'" 
          @click="showFeedbackHistory"
          class="btn_a btn_feedback complete"
          title="피드백 보기"
        >
          <i class="ph-bold ph-check-circle"></i> 피드백 완료
        </button>
      </div>
    </div>
    <!-- #### HEADER #### end -->

    <span id="etc-notice-sp">단위:만원</span>

    <!-- #### content/chapter #### start -->
    <div class="contents" v-if="chapterList">
      <div v-for="(chapter, key) in chapterList" :key="chapter.id || key" class="chapter"
     :class="{ fold: chapter.fold, wide: chapter.idx == '7' }">
        <h2 class="head" @click="foldOpenByKey(key)">
          {{ chapter.name }}
        </h2>
        <ul class="child" v-if="!chapter.fold">
          <template v-for="(item, j) in chapter.list" :key="j">
            <li :class="j" v-if="item.delegate === 1">
              <span>{{ item.name }}</span>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <!-- #### content/chapter #### end -->


    <!-- #### main #### start -->
    <div class="chart">

      <template v-if="solution.plan_list && solution.plan_list.length > 0">
        <div v-for="(plan, i) in solution.plan_list" v-bind:key="i" class="plan">
          
          <!-- #### 증권 정보 #### start -->
          <div class="plan-info">
            <ul @click="editPlan(plan)">
              <li> <img :src="getInsuCompanyInfo(plan.company).short_img "></li>
              <li> <h2>{{ getInsuCompanyInfo(plan.company).value == '' ? plan.company_etc : getInsuCompanyInfo(plan.company).name }}</h2></li>
              <li> <span v-if="plan.type_id == 0">{{ plan.type }} </span> <span v-if="plan.type_id != 0">{{ getTypeTypeLabel(plan.type_id) }} </span> </li>
              <!-- 품명 <li> <span>{{ plan.sub_type }}</span> </li> -->
              <li> 
                <span>
                  {{ plan.pay_type < 2 ? plan.pay : '' }}{{ getPayTypeLabel(plan.pay_type) }} /
                  {{ plan.end_type < 2 ? plan.end : '' }} {{ getEndTypeLabel(plan.end_type) }}
                </span>
              </li>
              <!-- 갱신 <li> <span>{{ getRenewableLabel(plan.renewable) }}</span> </li> -->
              <li> <span>가입:{{ plan.joined_at }}</span> </li>
              <li> <h2>{{ formatMoney(plan.price) }}원</h2> </li>
            </ul>
            <div class="control">
              <!-- <p @click="editPlan(plan)"><i class="ph ph-pencil-simple"></i></p> -->
              <p @click="downloadPlan(plan)"><i class="ph ph-download-simple"></i> </p>
              <p @click="deletePlan(plan)"><i class="ph ph-x"></i></p>
              <div class="pad">
                <p @click="planUpDown(plan, -1)"><i class="ph ph-caret-up"></i></p>
                <p @click="planUpDown(plan, 1)"><i class="ph ph-caret-down"></i></p>
              </div>
            </div>
          </div>
          <!-- #### 증권 정보 #### end -->
          
          <!-- #### 보장 내용 #### start -->
          <div class="coverage-list">
            <div v-for="(chapter, key) in chapterList" 
            :key="chapter.id || key" 
            class="coverage"
            :class="{ fold: chapter.fold, wide: chapter.idx == '7' }">

              <div class="list" v-if="chapter.fold" @click="editCoverage(plan.fake_idx, chapter.idx)">
                <ul class="dual-stack">
                  <template v-for="(child, j) in chapter.list" :key="j">
                    <template v-for="(item, k) in returnCoverages(plan.fake_idx, child.idx).filter(c => c.use).sort((a, b) => a.no - b.no)" :key="k">
                      <li :title="item.long_name" v-if="halfLettering && !coverage?.low_show" :class="{important:item?.style_important, bold: item?.style_bold}"> <span>{{ item.short_name || item.name.slice(0, 4) }}</span> <span>{{ formatMoney(item.value) }}</span> </li>
                      <li :title="item.long_name" v-if="!halfLettering && !coverage?.low_show" :class="{important:item?.style_important, bold: item?.style_bold}"> <span>{{ item.short_name || item.name.slice(0, 4) }}</span> <span>{{ formatMoney(item.value) }}</span> </li>
                    </template>
                  </template>
                </ul>
                <div class="other" v-if="getHiddenCountByChapter(plan.fake_idx, chapter) > 0"><span>미표시</span> <span>{{ getHiddenCountByChapter(plan.fake_idx, chapter) }}건</span></div>
                <span class="none" v-if="getCovsInChapter(plan, chapter).length === 0 && getHiddenCountByChapter(plan.fake_idx, chapter) == 0">눌러서 보장 추가</span>
              </div>
              <template v-for="(item, j) in chapter.list" :key="j">
                <div class="list folder" v-if="!chapter.fold" @click="editCoverage(plan.fake_idx, chapter.idx, item.idx)">
                  <ul class="dual-stack">
                    <template v-for="(coverage, k) in returnCoverages(plan.fake_idx, item.idx).sort((a, b) => a.no - b.no)" :key="k">
                      <li :title="coverage.long_name" v-if="!coverage.is_union && halfLettering && !coverage?.low_show" :class="{ important: coverage?.style_important, bold: coverage?.style_bold }"> <span>  {{ coverage.name }}</span> <span>{{ formatMoney(coverage.value) }}</span></li>
                      <li :title="coverage.long_name" v-if="!coverage.is_union && !halfLettering && !coverage?.low_show" :class="{ important: coverage?.style_important, bold: coverage?.style_bold }"> <span>  {{ coverage.short_name || coverage.name.slice(0, 4) }}</span> <span>{{ formatMoney(coverage.value) }}</span></li>
                    </template>
                  </ul>
                  <div class="other" v-if="getHiddenCount(plan.fake_idx, item.idx) > 0 && chapter.fold" ><span>미표시</span> <span>{{ getHiddenCount(plan.fake_idx, item.idx) }}건</span></div>
                  <span class="none" v-if="returnCoverages(plan.fake_idx, item.idx).length === 0 && getHiddenCount(plan.fake_idx, item.idx) == 0">눌러서 보장 추가</span>
                </div>
              </template>
            </div>
          </div>
          <!-- #### 보장 내용 #### end -->

        </div>
      </template>

      <!-- #### 추가 버튼 #### start -->
      <button @click="makePlan()" class="add-btn" title="플랜 추가"> <i class="ph-bold ph-plus"></i> 플랜 추가</button>
      <!-- #### 추가 버튼 #### end -->

    </div>
    <!-- #### main #### end -->

    <!-- #### 표형 인쇄용 테이블 #### start -->
    <div class="excel-table">
      <div class="excel-header">
        <div class="excel-title">
          <h1>보장 스케치 ({{ solutionInfo.type == 0 ? '제안' : '분석' }})</h1>
        </div>
        <div class="excel-info">
          <span>주피보험자: <strong>{{ connectedCustomer?.name || solutionInfo.client?.name }}</strong> 님</span>
          <span class="unit">단위: 만원</span>
        </div>
      </div>

      <table class="excel-unified-table">
        <thead>
          <tr class="header-main">
            <th rowspan="2" class="col-plan">보험상품</th>
            <th rowspan="2" class="col-narrow">사망보장<br><small>(상해,질병)</small></th>
            <th rowspan="2" class="col-narrow">후유장해<br><small>(상해,질병)</small></th>
            <th colspan="3" class="col-diagnosis">진단비<br><small>(3대 주요질병)</small></th>
            <th rowspan="2" class="col-coverage">수술비<br><small>(기본,주요)</small></th>
            <th rowspan="2" class="col-coverage">입원비<br><small>(기본,주요)</small></th>
            <th rowspan="2" class="col-coverage">치료비<br><small>(기본,주요)</small></th>
            <th rowspan="2" class="col-coverage">생활보장<br><small>(다빈도,필수)</small></th>
            <th rowspan="2" class="col-narrow">기타보장<br><small>(저비용,미분류)</small></th>
          </tr>
          <tr class="header-sub">
            <th class="col-sub">암</th>
            <th class="col-sub">뇌</th>
            <th class="col-sub">심</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(plan, i) in solution.plan_list" :key="i">
            <td class="plan-cell">
              <div class="plan-info-compact">
                <strong>{{ getInsuCompanyInfo(plan.company).name || plan.company_etc }}</strong>
                <span>{{ plan.type }}</span>
                <small>{{ plan.joined_at }}</small>
                <small>{{ plan.pay }}{{ getPayTypeShort(plan.pay_type) }}-{{ plan.end }}{{ getEndTypeShort(plan.end_type) }}</small>
                <em>{{ formatMoney(plan.price) }}원</em>
              </div>
            </td>
            <td><div class="cell-stack" v-html="getDelegateValues(plan.fake_idx, 'death')"></div></td>
            <td><div class="cell-stack" v-html="getDelegateValues(plan.fake_idx, 'disability')"></div></td>
            <td><div class="cell-stack" v-html="getDelegateValues(plan.fake_idx, 'cancer')"></div></td>
            <td><div class="cell-stack" v-html="getDelegateValues(plan.fake_idx, 'brain')"></div></td>
            <td><div class="cell-stack" v-html="getDelegateValues(plan.fake_idx, 'heart')"></div></td>
            <td><div class="cell-stack" v-html="getDelegateValues(plan.fake_idx, 'surgery')"></div></td>
            <td><div class="cell-stack" v-html="getDelegateValues(plan.fake_idx, 'hospital')"></div></td>
            <td><div class="cell-stack" v-html="getDelegateValues(plan.fake_idx, 'treatment')"></div></td>
            <td><div class="cell-stack" v-html="getDelegateValues(plan.fake_idx, 'living')"></div></td>
            <td><div class="cell-stack" v-html="getDelegateValues(plan.fake_idx, 'etc')"></div></td>
          </tr>
        </tbody>
      </table>

      <div class="excel-footer">
        <span>BODA</span>
        <span>상담사: {{ member_info.name }}</span>
      </div>
    </div>
    <!-- #### 표형 인쇄용 테이블 #### end -->

        

    <div class="footer closed">
      <div class="open_btn" @click="openFooter"> <span></span> </div>
      <div class="short">
        <ul style="flex:1; justify-content:flex-start;">
          <li> <span>합계</span> <h2> {{formatMoney(getSolutionPrice(solutionInfo.value))}}원 </h2> </li>
          <!-- <li @click="ratingSolution"> <span>평가</span> <div class="rate"> <i v-for="n in 5" :key="n" :class="n <= solutionInfo.rate ? 'ph-fill ph-star on' : 'ph ph-star'"></i> </div> </li> -->
        </ul>
        <span style="flex:1; text-align:center; color:var(--color-text-primary); font-size:14px; font-weight:800; opacity:0.5">미표시 항목은 첨부된 상세내역을 참조</span>
        <ul style="flex:1; justify-content:flex-end;">
          <li><span>플래너</span><h2>{{member_info.name}}</h2></li>
          <!-- <li><h2>VFT 파트너</h2></li> -->
        </ul>
      </div>
      <ul>
        <li v-for="chapter in chapterList" :key="chapter.idx">
          <template v-if="resultCovsByChapter[chapter.idx]">
            <!-- <div>{{ resultCovsByChapter[chapter.idx].name }}</div> -->  <!-- 챕터 제목 -->

            <!-- 중분류(예: 기본입원, 주요입원) 순회 -->
            <div class="dual-stack">
              <template v-for="(mid, midKey) in resultCovsByChapter[chapter.idx].items" :key="midKey">

                  <!-- <div class="mid-title">{{ mid.name || midKey }}</div>  -->  <!-- 챕터 제목 -->

                  <!-- 그 항목들의 리스트 순회 -->
                  <div v-for="item in (mid.list || [])" :key="item.idx">
                    <span>{{ item.short_name || (item.name && item.name.slice(0,4)) || item.name }}</span>
                    <span>{{ formatMoney(getResultFromUnionsChild(item)) }}</span>
                  </div>

              </template>
            </div>
          </template>
        </li>
      </ul>
      <!--
      <div class="last">
        <span>본 자료는 이해를 돕기위한 가상의  데이터로 실제 설계와 다를 수 있음으로 배포를 금지 합니다. (표시단위 : 만원)</span>
        <button>설계 요청</button>
      </div>
      -->
    </div>

  </div>

</template>


<script>
import { ref, inject, reactive, computed, watch, onBeforeUnmount } from 'vue';

import dialog_wheelDateChooser from '@/components/dialogs/wheelDateChooser.vue';
import dialog_solutionInfoEdit from '@/components/dialogs/solutionInfoEdit.vue';
import dialog_ratingView from '@/components/dialogs/ratingView.vue';
import dialog_companyPicker from '@/components/dialogs/insuCompanyPicker.vue';
import dialog_boardView from '@/components/dialogs/boardView.vue';
import dialog_caView from '@/components/dialogs/caView.vue';

export default {
  components: {
    dialog_wheelDateChooser,
    dialog_solutionInfoEdit,
    dialog_ratingView,
    dialog_companyPicker,
    dialog_boardView,
    dialog_caView
  },
  data() {
    return {
      pageId: "CoverageAnalysisDetail",
    };
  },
  props: {
    closeFunction:Function,
    p_solution:Object,
    reload: { type: Function, default: () => {} }
  },
  computed: {
    getCoveragesByChapter() {
      return (chapterIdx) =>
        (this.coverageList || []).filter(c => c.chapter_idx == chapterIdx);
    }
  },
  setup(props) {

    // 변수
    const hoverTimer = ref(null);

    const selectedSolution = ref(null);
    const showViewDialog = ref(false);
    const solutionInfo = ref(props.p_solution);
    if (!solutionInfo.value) { return }
    const sql_query = inject('sql_query');
    const insuCompanys = inject('insuCompanys');
    const getInsuCompanyInfo = inject('getInsuCompanyInfo');
    const coverageList = reactive([]);
    watch(coverageList, () => { coverageList.sort((a, b) => a.no - b.no) }, { deep: true } )
    const coverageOther = reactive([]);
    const dialogOpen = ref(false);
    const dialogSel = ref("edit-coverage");
    const editingPlan = ref ({});
    const editingChapter = ref({});
    const editingChapterParent = ref({});
    const IS_ex_coverages = ref([]);
    const show_suggestion = ref(false);
    const show_sub_suggestion = ref();
    const dialog_editing_cov = ref(false);
    const editingPlanForCov = ref({});
    const editingCoverage = ref(null);
    const system_show = ref(true);
    const system_show_info = ref({ title:'불러오는 중...', text:'보장을 불러오는 중 입니다.\n잠시만 기다려 주세요.' }); // 시스템 메시지 표시용
    const modal_show = ref(false);
    const modal_editing_choseChapter = ref(null);
    const modalConfirmHandler = ref(null);
    const showingReference = ref(false);
    const member_info = inject('member_info');
    const temp_sel_suggestion = ref(null);
    const print_mode = ref(false);
    const printMode = ref('card'); // 'card' 또는 'excel'
    const showPrintMenu = ref(false);
    
    // 챕터 영문명 매핑 (엑셀 인쇄용)
    const chapterMapping = {
      death: 'death',
      disability: 'aftereffect',
      cancer: 'three_major_cancer',
      brain: 'three_major_brain',
      heart: 'three_major_heart',
      surgery: 'surgery',
      hospital: 'hosp_fee',
      treatment: 'medical',
      living: 'living',
      etc: 'other',
    };
    
    const datePickerShow = ref(false); // 날짜 선택기 사용 여부
    const showSolutionInfoEdit = ref(false); // 솔루션 정보 수정 다이얼로그 표시 여부
    const editingSolutionForInfo = ref(null); // 솔루션 정보 수정 시 현재 편집 중인 솔루션
    const favPlanList = ref([]); // 즐겨찾기 플랜 목록
    let basic_profile_url = `/imgs/unknow_user.png`;
    const calculateInsuAge = inject('calculateInsuAge');
    let halfLettering = ref(false);
    let holdWatchCoverageList = false;
    let CoverageListChanged = 0;
    const showRatingView = ref(false); // 평가 다이얼로그 표시 여부
    const defRateValue = ref(0); // 기본 평가 값
    const watchingPost = ref(null);
    const showMore = ref(false);
    const nowNewAddCovTemp = ref(null);
    const connectedCustomer = ref(null);
    const tempEdCovSelChap = ref("사망보장");

    // 피드백 관련 상태
    const showFeedbackDialog = ref(false);
    const feedbackList = ref([]);

    // 피드백 요청
    async function requestFeedback() {
      // 1. 먼저 저장
      await saveSolution();
      
      // 2. 피드백 요청 상태로 변경
      const sql = `UPDATE IS_solution SET feedback_status = 'requested' WHERE idx = '${solutionInfo.value.idx}'`;
      await sql_query(sql);
      
      // 3. 피드백 테이블에 레코드 생성
      const insertSql = `INSERT INTO IS_solution_feedback SET 
        solution_idx = ${solutionInfo.value.idx},
        requester_id = '${member_info.mb_id}',
        status = 'requested',
        requested_at = NOW()`;
      await sql_query(insertSql);
      
      // 4. 상태 업데이트
      solutionInfo.value.feedback_status = 'requested';
      
      alert('피드백 요청이 완료되었습니다.\n관리자가 검토 후 피드백을 남길 예정입니다.');
    }

    // 피드백 이력 보기
// 피드백 이력 보기
async function showFeedbackHistory() {
  // 단순 쿼리로 테스트
  const sql = `
    SELECT * FROM IS_solution_feedback 
    WHERE solution_idx = ${solutionInfo.value.idx}
    ORDER BY requested_at DESC
  `;
  const result = await sql_query(sql);
  
  console.log('피드백 결과:', result);
  console.log('개수:', result.length);
  
  feedbackList.value = Array.isArray(result) ? result : [];
  showFeedbackDialog.value = true;
}

    // 피드백 어노테이션 보기 (caView에서 오버레이로)
    // viewFeedbackAnnotations 함수
    async function viewFeedbackAnnotations(fb) {
      let parsedAnnotations = [];
      if (fb.annotations) {
        try {
          parsedAnnotations = typeof fb.annotations === 'string' 
            ? JSON.parse(fb.annotations) 
            : fb.annotations;
        } catch (e) {
          console.error('annotations 파싱 실패:', e);
        }
      }
      
      selectedSolution.value = {
        ...solutionInfo.value,
        feedback_mode: 'view',
        feedback_idx: fb.idx,
        annotations: parsedAnnotations,
        comment: fb.comment || '',
      };
      
      showFeedbackDialog.value = false;
      showViewDialog.value = true;
    }

    function closeViewDialog() {
      showViewDialog.value = false;
      selectedSolution.value = null;
    }

    // 비교 솔루션 보기
    function viewComparisonSolution(feedback) {
      // TODO: 비교 모드로 caView 열기
      console.log('비교 보기:', feedback.comparison_solution_idx);
    }


    async function fetchConCus() {
      const query = `select * from customers where idx = '${solutionInfo.value.customer_idx}'`;
      const res = await sql_query(query);     // 실제 쿼리 실행
      connectedCustomer.value = res[0];       // 결과 저장
    }

    fetchConCus();


    function showMoreToggle() {
      showMore.value = !showMore.value;
    }

    function ratingSolution() {
      showRatingView.value = true;
      defRateValue.value = solutionInfo.value.rate || 0; // 현재 평가 값 설정
    }

    function handleRatingSubmit({rate}) {
      console.log("평가 점수: " + rate);
      solutionInfo.value.rate = rate;
      showRatingView.value = false;
      sql_query(`UPDATE IS_solution SET rate = ${rate} WHERE idx = '${solutionInfo.value.idx}'`);
    }

    watch(coverageList, (newVal) => {
      if (holdWatchCoverageList) return;
      CoverageListChanged++; 
      if(solution.value.plan_list.length >= CoverageListChanged) {
        console.log("coverageList changed", newVal);
      }
      
    }, { deep: true });

    function genderChoser(code) {
      if (!code || code == 0) {
        return '무성'
      }
      return code % 2 === 0 ? '여성' : '남성'
    }

    function reportWindowSize() {
      console.log("현재 화면 너비:", window.innerWidth);
      if (window.innerWidth < 1120) {
        halfLettering.value = false;
      } else {
        halfLettering.value = true;
      }
    }

    // 초기 너비 확인
    reportWindowSize();

    // 창 크기 변경 시 감지
    window.addEventListener('resize', reportWindowSize);

    function editSolutionInfo(b, solution) {
      showSolutionInfoEdit.value = b;
      editingSolutionForInfo.value = solution || null;
    }

    async function reloadSolutionInfo() {
      await props.reload();
      const sql = `SELECT * FROM IS_solution WHERE idx = '${solutionInfo.value.idx}'`;
      sql_query(sql).then(result => {
        if (result.length > 0) {
          const row = result[0];
          solutionInfo.value = {
            idx: row.idx,
            name: row.name,
            client: JSON.parse(row.client),
            created_at: row.created_at.slice(0, 10),
            status: row.status,
            price: row.price,
            purpose: row.purpose || '', // 컨설팅 목적 추가
            mb_id: row.mb_id,
            rate: row.rate || 0, // 평가 점수 추가
            type: row.type || 0,
            customer_idx: row.customer_idx || 0,
            feedback_status: row.feedback_status || 'none',
          };
        }
      });
    }

    /*
    const selectCoverage = reactive({});
    const usingSuggestion = ref(false);
    const suggestionList = ref([]);
    */
    const chapterList = ref({});
    const solution = ref({ plan_list: [] });

    // 챕터 로드
    async function fetchChapter() {
      // 1. 부모 챕터 (parent is NULL or 0)
      const rootSql = `SELECT * FROM IS_chapter WHERE (parent IS NULL OR parent = 0) AND status = 1 ORDER BY no ASC`;
      const rootChapters = await sql_query(rootSql);

      // en_name 기반 구조 생성
      for (const chapter of rootChapters) {
        chapterList.value[chapter.en_name] = {
          idx: chapter.idx,
          no: chapter.no,
          name: chapter.name,
          delegate: chapter.delegate,
          show_type: chapter.show_type || 0, // 0:합산, 1:건수, 2:지정
          fold: true,
          is_oth: chapter.is_oth || 0,
          list: {}
        };
      }

      // 2. 자식 챕터
      const childSql = `SELECT * FROM IS_chapter WHERE parent IS NOT NULL AND parent != 0 AND status = 1 ORDER BY no ASC`;
      const childChapters = await sql_query(childSql);

      for (const chapter of childChapters) {
        const parentObj = rootChapters.find(r => r.idx === chapter.parent);
        if (!parentObj || !chapterList.value[parentObj.en_name]) continue;

        chapterList.value[parentObj.en_name].list[chapter.en_name] = {
          name: chapter.name,
          idx: chapter.idx,
          delegate: chapter.delegate,
          show_type: chapter.show_type || 0, // 0:합산, 1:건수, 2:지정
          is_oth: chapter.is_oth || 0,
          no: chapter.no,
        };
      }
    }
    fetchChapter();

    // 플랜 로드
    async function fetchPlans() {
      const sql = `SELECT * FROM IS_plan where solution_id = '${solutionInfo.value.idx}' ORDER BY number ASC LIMIT 0, 30`;
      const result = await sql_query(sql);
      for (const plan of result) {

        let s_plan = reactive({
          no: plan.number,
          idx: plan.idx,
          fake_idx: plan.idx || 0, // 임시로 사용하기 위한 fake idx
          name: plan.name,
          pay: plan.pay,
          pay_type: plan.pay_type || 0, // 납기 유형
          end: plan.end,
          end_type: plan.end_type || 0, // 만기 유형
          price: plan.price,
          type: plan.type,
          type_id: plan.type_id || 0, // 보험종류
          sub_type: plan.sub_type,
          joined_at: (plan.joined_at || '').slice(0, 10), // 가입일
          company: plan.company,
          company_etc: plan.company_etc || '', // 보험사 기타
          coverages: {},
          renewable: plan.renewable || 0, // 갱신 여부
          remarks: plan.remarks || '', // 비고
          worth: plan.worth || 0, // 보장금액
          return_worth: plan.return_worth || 0, // 환급금
          fav: plan.fav || 0, // 즐겨찾기 여부
        });

        solution.value.plan_list.push(s_plan);
        fetchCoverages();
      }

      // 만약 플랜 없으면 
      if (solution.value.plan_list.length === 0) {
        system_show.value = false;
      }

      console.log("플랜 불러오기 완료", solution.value.plan_list);
    }
    fetchPlans();


    // 보장 불러와서 ary에 넣기
    let covFetchRun = false;
    async function fetchCoverages() {
      if (covFetchRun) return;
      covFetchRun = true;

      const plans = solution.value.plan_list;

      // 1. 모든 원본 보장을 미리 불러와서 Map으로 만들기
      const originals = await sql_query(`SELECT * FROM IS_ex_coverage`);
      const originalMap = new Map(originals.map(o => [o.idx, o]));

      // 2. 모든 플랜별 보장 SELECT 병렬로 수행
      const planTasks = plans.map(async (plan) => {
        const sql = `SELECT * FROM IS_coverage WHERE plan_id = ${plan.idx} ORDER BY idx DESC`;
        const coverages = await sql_query(sql);
        return { plan, coverages };
      });

      const allPlanCoverage = await Promise.all(planTasks);

      // 3. 각 플랜의 보장을 coverageList 에 넣음
      for (const { plan, coverages } of allPlanCoverage) {
        for (const coverage of coverages) {
          const original = originalMap.get(coverage.original);

          coverageList.push({
            idx: coverage.idx,
            name: coverage.nick || original?.name || '',
            no: original?.no || 9999,
            short_name: coverage.short_name || original?.short_name || '',
            long_name: coverage.long_name || original?.long_name || '',
            chapter_idx: coverage.chapter_id || original?.chapter_id,
            plan_idx: coverage.plan_id,
            plan_fake_idx: plan.fake_idx,
            value: coverage.value,
            parent: coverage.parent || '',
            fold: false,
            showAdd:false,
            use: coverage.visible || false,
            calculable: coverage.calculable || false,
            cal_vis: (coverage.calculable || coverage.visible) ? 1 : 0,
            visible: true,
            description: original?.description || '',
            showDescription: false,
            searchable: coverage.searchable || false,
            suggestion: coverage.suggestion || false,
            style_bold: original?.style_bold || 0,
            style_important: original?.style_important || 0,
            original_idx: coverage.original,
            linked_ref: original?.linked_ref || '',
            period_value: coverage.period_value || 0, // 기간 INT
            period_type: coverage.period_type || '세', // 기간 유형
            renewable : coverage.renewable || 0, // 갱신 여부
            premium : coverage.premium || 0, // 보험료
            is_union : coverage?.is_union || 0, // 병합 여부
            low_show : coverage?.low_show || 0, // 미표시
          });
        }
      }

      // 마지막에 solution 구조에 넣기
      addCoverageToSolution();
      system_show.value = false;
    }


    // 보장을 solution.coverages 챕터별로 추가
    async function addCoverageToSolution() {
      await solution.value.plan_list.forEach(plan => {
        Object.values(chapterList.value).forEach(chapter => {
          if (!plan.coverages[chapter.idx]) {
            let a = [];
            a['name'] = `${chapter.name}`;
            Object.values(chapter.list).forEach(child => {
              const coverages = returnCoverages(plan.idx, child.idx);
              a[child.idx] = { idx:child.idx, name:child.name, list:coverages };
            });
            plan.coverages[chapter.idx] = a;
          }

          const coverages = returnCoverages(plan.idx, chapter.idx);
          if (coverages.length > 0) {
            plan.coverages[chapter.idx] = coverages;
          }
        });
      });
      
      await mergePlansCoverages();
    }

    // 챕터 펼치기
    function foldOpenByKey(key) {
      const current = chapterList.value[key];
      if (!current) return;

      const isFolded = current.fold;

      // 전체 다 닫고
      Object.values(chapterList.value).forEach(ch => {
        ch.fold = true;
      });

      // 선택한 것만 토글
      current.fold = !isFolded;
    }

    // 챕터로 보장 불러오기
    function returnCoverages(planFakeIdx, chapterIdx) {
      const result = coverageList.filter(
        c => c.chapter_idx == chapterIdx && c.plan_fake_idx == planFakeIdx
      );

      if (result.length === 0) {
        coverageOther.push({
          plan_fake_idx: planFakeIdx,
          chapter_idx: chapterIdx
        });
      }

      return result;
    }

    function returnCoverageTotalValue(planFakeIdx, chapter) {
      const coverages = returnCoverages(planFakeIdx, chapter.idx);
      if (!coverages || coverages.length === 0) return 0;

      if (chapter.show_type === 1) {
        // 건수 모드: use === 1 인 보장 개수
        return coverages.filter(cov => cov.calculable === 1).length;
      }

      // 합산 모드 (기본)
      return coverages.reduce((total, coverage) => {
        if (coverage.calculable != 1) return total;
        const value = parseFloat(coverage.value) || 0;
        return total + value;
      }, 0);
    }

    async function loadExCoverages() {
      const original = await sql_query(`SELECT * FROM IS_ex_coverage`);
      IS_ex_coverages.value = original;  // ✅ 전체 배열 통째로 대입 (반응성 보장)
    }
    loadExCoverages();

    function makePlan() {
      solution.value.plan_list.push({
        no: solution.value.plan_list.length + 1,
        idx: 0,
        fake_idx: Math.random() * 1000000, // 임시로 사용하기 위한 fake idx
        name: `플랜 ${solution.value.plan_list.length + 1}`,
        pay: 0,
        end: 0,
        price: 0,
        type: '',
        sub_type: '',
        company: '',
        coverages: {}
      });
      // 그리고 위치로 스크롤
      setTimeout(() => {
      const el = document.querySelector(`.plan:nth-child(${solution.value.plan_list.length})`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);

    }

    function deletePlan(plan) {
      let ask = confirm('정말 삭제하시겠습니까?');
      if (!ask) return;
      const index = solution.value.plan_list.indexOf(plan);
      if (index > -1) {
        solution.value.plan_list.splice(index, 1);
      }
      // 보장도 삭제
      coverageList.value = coverageList.filter(cov => cov.plan_fake_idx !== plan.fake_idx);
    }

    async function saveSolution() {
      console.log(`📝 솔루션 저장 시작: ${solutionInfo.value}`);

      // 시스템 로딩 표시
      system_show_info.value = {
        title: "저장 중 ...",
        text: "종료 시 내용이 저장되지 않을 수 있습니다!"
      };
      system_show.value = true;

      // 1. 기존 플랜 idx 가져오기
      const existingPlans = await sql_query(`SELECT idx FROM IS_plan WHERE solution_id = '${solutionInfo.value.idx}'`);
      const existingIdxList = existingPlans.map(p => p.idx);

      // 2. 현재 UI 상에 있는 플랜 중 idx가 존재하는 애들
      const activeIdxList = solution.value.plan_list
        .filter(p => p.idx > 0)
        .map(p => p.idx);

      // 3. 삭제 대상
      const toDeleteIdxList = existingIdxList.filter(idx => !activeIdxList.includes(idx));
      await Promise.all(toDeleteIdxList.map(async (idx) => {
        try {
          await sql_query(`DELETE FROM IS_plan WHERE idx = ${idx}`);
          await sql_query(`DELETE FROM IS_coverage WHERE plan_id = ${idx}`);
          console.log(`🗑️ 삭제된 플랜 및 보장: ${idx}`);
        } catch (error) {
          console.error(`❌ 삭제 실패 (idx: ${idx}):`, error);
        }
      }));

      // 4. 플랜 + 보장 저장을 병렬 처리
      await Promise.all(solution.value.plan_list.map(async (plan) => {
        const isNew = plan.idx === 0;

        const escape = (str) => {
          if (typeof str !== 'string') {
            str = String(str ?? '');
          }
          return str.replace(/'/g, "\\'");
        };

        if (!member_info.mb_id) {
          alert('로그인 후 재시도 해주세요.');
          return;
        }

        const sql = isNew
          ? `INSERT INTO IS_plan SET 
              mb_id = '${member_info.mb_id}', 
              solution_id = ${solutionInfo.value.idx}, 
              name = '${escape(plan.name) || '플랜'}', 
              number = ${plan.no || 0}, 
              pay = '${escape(plan.pay) || '0'}', 
              pay_type = '${escape(plan.pay_type || '')}', 
              end = '${escape(plan.end) || '0'}', 
              end_type = '${escape(plan.end_type || '')}', 
              price = '${escape(plan.price) || '0'}', 
              type = '${escape(plan.type) || '기본'}', 
              type_id = ${plan.type_id || 0}, 
              renewable = ${plan.renewable || 0}, 
              worth = ${plan.worth || 0}, 
              return_worth = ${plan.return_worth || 0}, 
              remarks = '${escape(plan.remarks) || '비고 없음'}', 
              joined_at = ${plan.joined_at ? `'${plan.joined_at}'` : 'NULL'}, 
              sub_type = '${escape(plan.sub_type) || '기본'}', 
              company = '${escape(plan.company) || '기본'}',
              company_etc = '${plan.company_etc || ''}'`
          : `UPDATE IS_plan SET 
              mb_id = '${member_info.mb_id}', 
              name = '${escape(plan.name) || '플랜'}', 
              number = ${plan.no || 0}, 
              pay = '${escape(plan.pay) || '0'}', 
              pay_type = '${escape(plan.pay_type || '')}', 
              end = '${escape(plan.end) || '0'}', 
              end_type = '${escape(plan.end_type || '')}', 
              price = '${escape(plan.price) || '0'}', 
              type = '${escape(plan.type) || '기본'}', 
              type_id = ${plan.type_id || 0}, 
              renewable = ${plan.renewable || 0}, 
              worth = ${plan.worth || 0}, 
              return_worth = ${plan.return_worth || 0}, 
              remarks = '${escape(plan.remarks) || '비고 없음'}', 
              joined_at = ${plan.joined_at ? `'${plan.joined_at}'` : 'NULL'}, 
              sub_type = '${escape(plan.sub_type) || '기본'}', 
              company = '${escape(plan.company) || '기본'}',
              company_etc = '${plan.company_etc || ''}'
            WHERE idx = ${plan.idx}`;

            console.log(`💾 플랜 ${plan.name} 저장 SQL:`, sql);


        try {
          const result = await sql_query(sql);
          if (isNew) plan.idx = result.insertId;
          console.log(`📦 플랜 ${plan.name} 저장 완료`);

          // 보장 저장도 병렬 호출 안에서
          await saveCoverages(plan);

          let sql2 = `UPDATE IS_solution SET updated_at = now() WHERE idx = '${solutionInfo.value.idx}'`;
          await sql_query(sql2);

          console.log('rm check sql ', connectedCustomer.value);
          if (connectedCustomer.value.idx != 0) {
            let cs_sql = `UPDATE customers SET last_touch = now() where idx = '${connectedCustomer.value.idx}' `;
            console.log('rm check sql ', cs_sql);
            // sql_query(cs_sql);
          }

        } catch (error) {
          console.error(`❌ 저장 실패 (플랜 ${plan.name}):`, error);
        }
      }));

      // 시스템 로딩 표시 해제
      system_show.value = false;
    }


    async function saveCoverages(plan) {
      // 1. 기존 보장 삭제
      await sql_query(`DELETE FROM IS_coverage WHERE plan_id = ${plan.idx}`);

      const covs = coverageList.filter(c => c.plan_fake_idx === plan.fake_idx);
      const coverageIdMap = new Map(); // old idx → new insertId
      const deferred = []; // parent 있는 애들 따로

      // 2. parent 없는 보장 병렬 insert
      const insertPromises = covs.map(async cov => {
        if (!cov.parent || isNaN(cov.parent)) {
          let sql = `INSERT INTO IS_coverage SET
            plan_id = '${plan.idx}',
            chapter_id = '${cov.chapter_idx}',
            original = ${cov.original_idx || 'NULL'},
            nick = '${cov.name.replace(/'/g, "\\'")}',
            value = '${cov.value || '0'}',
            parent = NULL,
            visible = ${cov.use || 0},
            calculable = ${cov.calculable || 0},
            style_important = ${cov?.style_important || 0},
            style_bold = ${cov?.style_bold || 0},
            period_value = ${cov.period_value || 0},
            period_type = '${cov.period_type || '년'}',
            renewable = ${cov.renewable || 0},
            premium = ${cov.premium || 0},
            is_union = ${cov.is_union || 0}`
          const result = await sql_query(sql);

          console.log(sql)
          
          coverageIdMap.set(cov.idx, result.insertId);
        } else {
          deferred.push(cov);
        }
      });

      await Promise.all(insertPromises); // 병렬 처리 완료

      // 3. parent 있는 보장 insert (부모 ID 매핑 이후)
      const deferredPromises = deferred.map(async cov => {
        const parentNewId = coverageIdMap.get(cov?.parent);
        if (!parentNewId) {
          console.warn(`⚠️ parent ID 매핑 실패: ${cov.name} → ${cov?.parent}`);
          return;
        }

        let sql = `INSERT INTO IS_coverage SET
          plan_id = '${plan.idx}',
          chapter_id = '${cov.chapter_idx}',
          original = ${cov.original_idx || 'NULL'},
          nick = '${cov.name.replace(/'/g, "\\'")}',
          value = '${cov.value || '0'}',
          parent = ${parentNewId || null},
          style_important = ${cov?.style_important || 0}, 
          style_bold = ${cov?.style_bold || 0},
          visible = ${cov.use || 0},
          calculable = ${cov.calculable || 0},
          period_value = ${cov.period_value || 0},
          period_type = '${cov.period_type || '년'}',
          renewable = ${cov.renewable || 0},
          premium = ${cov.premium || 0},
          is_union = ${cov.is_union || 0}`;
        const result = await sql_query(sql);

        console.log(sql)

        coverageIdMap.set(cov.idx, result.insertId); // 자식도 매핑
      });

      await Promise.all(deferredPromises); // 병렬 처리 완료

      console.log(`🛡️ 보장 ${covs.length}건 저장 완료 (플랜 ${plan.idx})`);
    }


    function openDialog(b) {
      dialogOpen.value = b;
      // input 비우기
      CoverageNameForAdd.value = '';
      CoverageValueForAdd.value = '';
      dialog_editing_cov.value = false;
      showMore.value = false;
      modalOpen(false);
      if (nowNewAddCovTemp.value && b) {
        nowNewAddCovTemp.value.showAdd = false;
      }

    }

    function editPlan(plan) {
      editingPlan.value = plan;
      dialogSel.value = "edit-plan";
      openDialog(true);
    }


    function getChapterByIdx(target_idx) {
      const chapters = chapterList.value;

      for (const [categoryKey, group] of Object.entries(chapters)) {
        // 상위 chapter idx가 일치하면 바로 리턴
        if (group.idx === target_idx) {
          return {
            type: 'chapter',
            category: categoryKey,
            item: group,
          };
        }

        // 하위 항목 순회
        for (const [itemKey, item] of Object.entries(group.list)) {
          if (item.idx === target_idx) {
            return {
              type: 'item',
              category: categoryKey,
              itemKey,
              item,
            };
          }
        }
      }

      return null; // 못 찾았을 때
    }

    function getChapterParentByIdx(target_idx) {
      const chapter = getChapterByIdx(target_idx);
      if (!chapter) return null;

      // 상위 챕터의 name을 반환
      return chapterList.value[chapter.category]?.name || null;
    }

    
    /*
    function getChapterParentByEnName(en_name) {
      const chapters = chapterList.value;
      return chapters[en_name]?.name || null;
    }
    */


    function editCoverage(planFakeIdx, chapterParentIdx, chapterChildIdx) {
      
      const plan = solution.value.plan_list.find(p => p.fake_idx === planFakeIdx);
      editingPlan.value = plan;

      editingChapterParent.value = getChapterByIdx(chapterParentIdx);
      editingPlanForCov.value = plan;

      if (chapterChildIdx) {
        editingChapter.value = getChapterByIdx(chapterChildIdx);
      } else {
        editingChapter.value = null;
      }
      dialogSel.value = "edit-coverage";
      openDialog(true);
      mergePlansCoverages();
    }


    function flattenCoverageTree(list) {
      const map = new Map();
      const roots = [];

      list.forEach(item => {
        item.children = [];
        map.set(item.idx, item);
      });

      map.forEach(item => {
        if (item.parent && !isNaN(item.parent)) {
          const parentId = Number(item.parent);

          // 자기 자신을 부모로 지정한 경우 → 무시
          if (parentId === item.idx) {
            console.warn("자기 자신을 부모로 지정한 항목:", item);
            roots.push(item);
            return;
          }

          const parent = map.get(parentId);
          if (parent) {
            parent.children.push(item);
          } else {
            roots.push(item);
          }
        } else {
          roots.push(item);
        }
      });

      // 순환 참조 방지: 방문 기록
      const visited = new Set();

      function assignDepth(node, depth = 0) {
        if (visited.has(node.idx)) {
          console.warn("순환 참조 감지됨:", node);
          return;
        }
        visited.add(node.idx);

        node._depth = depth;
        node.children.forEach(child => assignDepth(child, depth + 1));
      }

      roots.forEach(root => assignDepth(root));

      return roots;
    }


    function orderedCoverages(editPlanIdx, editingChapterIdx) {
      return flattenCoverageTree(
        returnCoverages(
          editPlanIdx,
          editingChapterIdx
        )
      );
    }

    function getSortedChildren(coverage) {
      return (coverage.children || []).slice().sort((a, b) => a.no - b.no);
    }




    const editCoverageFold = (coverage) => {
      // fold 상태 토글
      coverage.fold = !coverage.fold;

      // 자식들의 visible 상태를 fold 여부에 따라 조정
      coverageList.forEach(c => {
        if (c.parent == coverage.idx) {
          c.visible = !coverage.fold;
        }
      });
    };


    // delete Coverage
    const deleteCoverage = (coverage) => {
      let ask = confirm('정말 삭제하시겠습니까?');
      if (!ask) return;
      if (!coverage || typeof coverage.idx === 'undefined') {
        console.error('❌ deleteCoverage: Invalid coverage object:', coverage);
        return;
      }

      const toDeleteIdxSet = new Set();

      function collectChildren(node) {
        if (!node || typeof node.idx === 'undefined') return;

        toDeleteIdxSet.add(node.idx);

        // node.children이 없다면 무시
        if (Array.isArray(node.children)) {
          node.children.forEach(child => collectChildren(child));
        }
      }

      collectChildren(coverage);

      // coverageList에서 해당 idx들을 제거
      for (let i = coverageList.length - 1; i >= 0; i--) {
        if (toDeleteIdxSet.has(coverageList[i].idx)) {
          coverageList.splice(i, 1);
        }
      }
    };


    const CoverageNameForAddSub = ref('');
    const CoverageValueForAddSub = ref('');
    function addChildCoverage(parentCoverage, addCov, value) {

      if (!parentCoverage || typeof parentCoverage.idx === 'undefined') {
        console.error('❌ addChildCoverage: Invalid parent coverage:', parentCoverage);
        return;
      }

      // 원본이 없는데, 이름만 있다면 IS_ex_coverages에서 검색 후 이름이 같다면 원본으로 사용
      if (addCov == null && CoverageNameForAddSub.value) {
        addCov = IS_ex_coverages.value.find(item => item.name == CoverageNameForAddSub.value.trim() );
      } 

      if (addCov == null && CoverageValueForAddSub.value) {
        addCov = IS_ex_coverages.value.find(item => item.value == CoverageValueForAddSub.value.trim() );
      }

      if (!addCov || typeof addCov.idx === 'undefined') {
        const newCoverage = {
          idx: Date.now() + Math.floor(Math.random() * 1000), // 충돌 방지
          name: CoverageNameForAddSub.value || '새 보장',
          no: 9999, // 기본값
          short_name: '',
          long_name: '',
          original_idx: null,
          chapter_idx: parentCoverage.chapter_idx,
          plan_fake_idx: parentCoverage.plan_fake_idx,
          calculable: 0,
          searchable: 0,
          suggestion: 0,
          style_important: 0,
          style_bold: 0,
          period_value: 0,
          period_type: '년',
          renewable: 0,
          premium: 0,
          value: value || "0",
          parent: parentCoverage.idx,
          description: '',
          showDescription: false,
          linked_ref: null,
          fold: false,
          showAdd: false,
          use: 0,
          visible: true,
          is_union: 0,
          low_show: 0,
        };
        
        coverageList.push(newCoverage);
      } else {
        const newCoverage = {
          idx: Date.now() + Math.floor(Math.random() * 1000), // 충돌 방지
          name: addCov.name || '새 보장',
          no: addCov.no || 9999, // 기본값
          short_name: addCov.short_name || addCov.name.slice(0, 4), // 앞 4자만
          long_name: addCov.long_name || '',
          original_idx: addCov.idx || null,
          chapter_idx: parentCoverage.chapter_idx,
          plan_fake_idx: parentCoverage.plan_fake_idx,
          calculable: addCov.calculable || 0,
          searchable: addCov.searchable || 0,
          suggestion: addCov.suggestion || 0,
          style_important: addCov?.style_important || 0,
          style_bold: addCov?.style_bold || 0,
          period_value: addCov.period_value || 0,
          period_type: addCov.period_type || '년',
          renewable: addCov.renewable || 0,
          premium: addCov.premium || 0,
          value: value || "0",
          parent: parentCoverage.idx,
          description: addCov?.description || '',
          showDescription: false,
          linked_ref: addCov.linked_ref || null,
          fold: false,
          showAdd: false,
          use: addCov.sel ? 1 : 0,
          visible: true,
          is_union: addCov?.is_union || 0,
          low_show: addCov?.low_show || 0,
        };
        
        coverageList.push(newCoverage);
      }

      
      parentCoverage.showAdd = false;
      CoverageNameForAddSub.value = '';
      CoverageValueForAddSub.value = '';
      CoverageValueForAdd.value = '';
      CoverageNameForAdd.value = '';
      show_sub_suggestion.value = false;
    }

    const CoverageNameForAdd = ref('');
    const CoverageValueForAdd = ref('');
    // const addingNow = ref(false);
    async function addCoverage(original_idx) {
      const plan = editingPlanForCov.value;

      let original = null;
      if (original_idx) {
        original = IS_ex_coverages.value.find(item => item.idx === original_idx);
      }

      // 원본이 없는데, 이름만 있다면 IS_ex_coverages에서 검색 후 이름이 같다면 원본으로 사용
      if (original == null && CoverageNameForAdd.value) {
        original = IS_ex_coverages.value.find(item => item.name == CoverageNameForAdd.value.trim() );
        original_idx = original ? original.idx : null;
      } 

      // 원본도, 이름도 없으면 취소
      if (!original && CoverageNameForAdd.value == "") {
        // 원본만 있는 경우 updown 선택한거임
        if (original) {
          return;
        } else {
          alert('보장 이름을 입력해주세요');
          return;
        }
      }

      // 부모가 있다면 먼저 부모가 존재하는지 확인
      if (original && original.parent) {
        const parentCoverage = coverageList.find(c => c.original_idx === original.parent && c.plan_fake_idx === plan.fake_idx);

        if (parentCoverage) {
          // 부모가 있으면 자식만 추가
          const ChapterIdForAdd = await askChapterToMoveCov(original);
          if (!ChapterIdForAdd) {  return; }
          addChildCoverage(parentCoverage, original, CoverageValueForAdd.value);
          return;
        } else {
          // 부모 original 찾기
          const parentOriginal = IS_ex_coverages.value.find(item => item.idx === original.parent);
          if (!parentOriginal) { return; }

          const ChapterIdForAdd = await askChapterToMoveCov(original);
          if (!ChapterIdForAdd) { return; }
          
          // 부모 보장 먼저 생성
          const parentCoverageNew = {
            idx: Date.now() + Math.floor(Math.random() * 1000),
            name: parentOriginal.name,
            no: parentOriginal.no || 9999,
            short_name: parentOriginal.short_name || '',
            long_name: parentOriginal.long_name || '',
            chapter_idx: parentOriginal.chapter_id || null, // 여기도 수정
            plan_fake_idx: plan.fake_idx,
            value: parentOriginal.value?.toString() || "0",
            original_idx: parentOriginal.idx,
            calculable: parentOriginal.calculable || 0,
            searchable: parentOriginal.searchable || 0,
            suggestion: parentOriginal.suggestion || 0,
            style_important: parentOriginal?.style_important || 0,
            style_bold: parentOriginal?.style_bold || 0,
            period_value: parentOriginal.period_value || 0,
            period_type: parentOriginal.period_type || '년',
            renewable: parentOriginal.renewable || 0,
            premium: parentOriginal.premium || 0,
            parent: null,
            linked_ref: parentOriginal.linked_ref || null,
            fold: false,
            showAdd: false,
            description: parentOriginal?.description || '',
            showDescription: false,
            use: parentOriginal?.sel || 0,
            visible: true,
            is_union: parentOriginal?.is_union || 0,
            low_show: parentOriginal?.low_show || 0,
          };
          coverageList.push(parentCoverageNew);

          // 그 다음 자식 보장 추가
          addChildCoverage(parentCoverageNew, original, CoverageValueForAdd.value);
          return;
        }
      } else {
        console.log(original);
        const ChapterIdForAdd = await askChapterToMoveCov(original);
        if (ChapterIdForAdd) {
          const newCoverage = {
            idx: Date.now() + Math.floor(Math.random() * 1000),
            name: original?.name || CoverageNameForAdd.value || '새 보장',
            short_name: original?.short_name || CoverageNameForAdd.value.slice(0,4), // CoverageNameForAdd.value가 4자 이상이면 앞 4자만
            long_name: original?.long_name,
            no: original?.no || 9999, // 원본이 없으면 9999로 설정
            chapter_idx: original?.chapter_id || ChapterIdForAdd || null, // 기존: chapter.idx → 수정
            plan_fake_idx: plan.fake_idx,
            value: original?.value?.toString() || CoverageValueForAdd.value || "0",
            original_idx: original_idx || null,
            calculable: original?.calculable || 0,
            searchable: original?.searchable || 0,
            suggestion: original?.suggestion || 0,
            style_important: original?.style_important || 0,
            style_bold: original?.style_bold || 0,
            period_value: original?.period_value || 0,
            period_type: original?.period_type || '년',
            renewable: original?.renewable || 0,
            premium: original?.premium || 0,
            parent: null,
            fold: false,
            linked_ref: original?.linked_ref || null,
            showAdd: false,
            description: original?.description || '',
            showDescription: false,
            use: original?.sel || 0,
            visible: true,
            is_union: original?.is_union || 0,
            low_show: original?.low_show || 0,
          };
          coverageList.push(newCoverage);
        }
        
      }

      // reset
      CoverageNameForAdd.value = '';
      CoverageValueForAdd.value = '';
      show_suggestion.value = false;
      mergePlansCoverages();
    }

    // 미확인 cov 일때 물어보고 추가
function askChapterToMoveCov(original) {
  return new Promise((resolve) => {
    modal_editing_choseChapter.value = {}; // 초기화

    // original이 존재하고 chapter_id가 있는 경우 먼저 챕터 리스트를 순회
    if (original?.chapter_id) {
      for (const chapter of Object.entries(editingChapterParent.value.item.list)) {
        if (original.chapter_id == chapter[1].idx) {
          // 이미 챕터가 지정되어 있다면 바로 반환
          return resolve(original.chapter_id);
        }
      }
    }

    // original이 없거나, chapter_id가 없거나, 챕터 일치 항목이 없을 경우
    if (!original) {
      if (editingChapter.value) {
        // editingChapter를 기본 선택지로 추가
        modal_editing_choseChapter.value = {
          [editingChapter.value.itemKey]: {
            idx: editingChapter.value.item.idx,
            name: editingChapter.value.item.name,
            delegate: false,
          }
        };
      } else {
        // 모든 챕터를 기본 선택지로 추가
        for (const [key, chapter] of Object.entries(editingChapterParent.value.item.list)) {
          modal_editing_choseChapter.value[key] = {
            idx: chapter.idx,
            name: chapter.name,
            delegate: false,
          };
        }
      }

      // 기타 챕터 처리
      const othChapter = Object.values(chapterList.value).find(ch => ch.is_oth === 1);
      const firstChild = Object.values(othChapter?.list ?? {})[1]; // 두 번째 자식

      if (firstChild) {
        modal_editing_choseChapter.value[firstChild.en_name || `oth_${firstChild.idx}`] = {
          idx: firstChild.idx,
          name: firstChild.name,
          delegate: true,
        };
      }
    } else {
      // original은 있는데 chapter 매칭이 안된 경우 → 강제로 그 chapter 추가
      const that_chapter = getChapterByIdx(original.chapter_id);
      modal_editing_choseChapter.value = {
        [that_chapter?.item.idx]: {
          idx: that_chapter?.item.idx,
          name: that_chapter?.item.name || '기타',
          delegate: true,
        }
      };
    }

    modalOpen(true);

    // 선택되었을 때 resolve
    modalConfirmHandler.value = (selectedIdx) => {
      modalOpen(false);
      resolve(selectedIdx);
    };
  });
}


    function selectChapterToMoveCov(idx) {
      modalConfirmHandler.value?.(idx); // <- 선택된 챕터 idx를 resolve
    }


    // suggestion 목록
    const filteredExCoverages = computed(() => {
      const baseList = IS_ex_coverages.value;
      const searchTerm = (CoverageNameForAdd.value?.toLowerCase() ?? "").replace(/[0-9]/g, "");  // 검색어 자체에서 숫자를 제외
      const filteredSet = new Set();

      // 1. 입력값 있을 때: 이름 기반 필터
      if (searchTerm) {
        return baseList
          .filter(cov =>
            cov.searchable !== 0 &&
            (cov.tags.toLowerCase().includes(searchTerm.replace(/\s+/g, "")) ||
            cov.name.toLowerCase().includes(searchTerm))
          )
          .sort((a, b) => a.no - b.no);
      }

      // 2. 입력값 없을 때: 챕터 기반 필터
      return baseList
        .filter(cov => {

          if (showMore.value) {
            if (filteredSet.has(cov.idx) || cov.searchable !== 1) return false;
          } else {
            if (cov.suggestion != 1 || filteredSet.has(cov.idx) || cov.searchable !== 1 ) return false;
          }

          const isInChapter = editingChapter.value ? cov.chapter_id === editingChapter.value.item.idx : Object.values(editingChapterParent.value.item.list).some(ch => ch.idx === cov.chapter_id);

          if (isInChapter) {
            filteredSet.add(cov.idx);
            return true;
          }
          return false;
        })
        .sort((a, b) => a.no - b.no);

    });

    
    function onSubFocus(parentCov) {
      show_sub_suggestion.value = parentCov.original_idx;
      console.log('✅ Focused');
    }

    function onSubBlur(parentCov) {
      if (show_sub_suggestion.value != parentCov.original_idx) return;
      show_sub_suggestion.value = null;
      console.log('❌ Blurred');
    }
    
    function onFocus() {
      show_suggestion.value = true;
      console.log('✅ Focused');
    }

    function onBlur() {
      show_suggestion.value = false;
      showMore.value = false;
      console.log('❌ Blurred');
    }


    function planFav(plan) {
      if (!plan || typeof plan.idx === 'undefined') {
        console.error('❌ planFav: Invalid plan object:', plan);
        return;
      }

      const newFav = plan.fav == 1 ? 0 : 1; // 1이면 0, 아니면 1

      sql_query(`UPDATE IS_plan SET fav = ${newFav} WHERE idx = ${plan.idx}`)
        .then(() => {
          plan.fav = newFav;
          console.log(`⭐ 즐겨찾기 ${newFav ? '등록됨' : '해제됨'}: ${plan.idx}`);
        })
        .catch(err => {
          console.error('❌ 즐겨찾기 업데이트 실패:', err);
        });
    }


    function getHiddenCount(planFakeIdx, chapterIdx) {
      return coverageList.filter(c =>
        c.plan_fake_idx === planFakeIdx &&
        c.chapter_idx === chapterIdx &&
        c.use != 1 &&
        c.is_union == 0
      ).length;
    }

    function getHiddenCountByChapter(planFakeIdx, chapter) {
      let total = 0;
      Object.values(chapter.list).forEach(item => {
        total += coverageList.filter(c =>
          c.plan_fake_idx == planFakeIdx &&
          c.chapter_idx == item.idx &&
          c.use != 1 &&
          c.is_union == 0
        ).length;
      });
      return total;
    }

    function showEditCovDialog(b, coverage) {
      if (!b) {
        tempEdCovSelChap.value = "사망보장";
        dialog_editing_cov.value = false;
        editingCoverage.value = null;
        return;
      }

      if (!coverage || typeof coverage.idx === 'undefined') {
        console.error('❌ showEditCovDialog: Invalid coverage object:', coverage);
        return;
      }

      dialog_editing_cov.value = true;
      editingCoverage.value = coverage;

    
      if (coverage) {
        tempEdCovSelChap.value = getChapterParentByIdx(editingCoverage.value.chapter_idx);
      }
    }

    function planUpDown(plan, direction) {
      const list = solution.value.plan_list
      const index = list.indexOf(plan)

      if (index === -1) return // plan 못 찾음
      const targetIndex = index + direction

      // 경계 체크
      if (targetIndex < 0 || targetIndex >= list.length) return

      // 스왑
      const temp = list[targetIndex]
      list[targetIndex] = plan
      list[index] = temp

      // plan.no 업데이트
      list.forEach((p, i) => {
        p.no = i + 1; // 1부터 시작하도록
      });
    }

    function getChapterChild() {
      // 챕터 리스트에서 자식 챕터만 추출
      const chapters = Object.values(chapterList.value);
      return chapters.flatMap(chapter => {
        return Object.values(chapter.list).map(item => {
          return {
            ...item,
            _depth: 0, // 기본 깊이 0
            parent: chapter.name, // 부모 챕터 이름 추가
          };
        });
      });
    }

    function setCoverageNameForAdd(name) {
      CoverageNameForAdd.value = name;
      show_suggestion.value = false; // 자동으로 닫기
    }

    function getCovsInChapter(plan, chapter) {
      const covs = [];
      if (!plan || !chapter || !chapter.list) return covs;

      Object.values(chapter.list).forEach(item => {
        const coverages = returnCoverages(plan.fake_idx, item.idx) || [];
        coverages.forEach(cov => {
          covs.push(cov);
        });
      });

      return covs;
    }

    function getRenewableLabel(code) {
      return {
        0: "비갱신형",
        1: "갱신형",
        2: "일부갱신형",
        3: "기타(그외)"
      }[code] || "-";
    }

    // 금액 포맷팅 함수
    function formatMoney(val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function modalOpen(b) {
      modal_show.value = b;
    }

    async function openReference(bool, ref_id) {
      if (bool) {
        let res = await sql_query(`SELECT * FROM board_reference WHERE idx = ${ref_id} limit 1`);
        if (res?.[0]?.idx) {
          watchingPost.value = res[0];
          showingReference.value = true;
        }
      } else {
        watchingPost.value = null;
        showingReference.value = false;
      }
    }

    function changeShowType(chapter) {
      if (!chapter) {
        return;
      }

      chapter.show_type = (chapter.show_type + 1) % 2; // 0, 1 순환
    }

    function updateCovNameForAdd(e) {
      CoverageNameForAdd.value = e.target.value;
    }

    function suggestionMove(event) {
      if (event.key === "ArrowDown") {
        temp_sel_suggestion.value = (temp_sel_suggestion.value + 1) % filteredExCoverages.value.length;
      } else if (event.key === "ArrowUp") {
        temp_sel_suggestion.value = (temp_sel_suggestion.value - 1 + filteredExCoverages.value.length) % filteredExCoverages.value.length;
      } else if (event.key === "Tab") {
        if (CoverageNameForAdd.value == '') {
          event.preventDefault(); // Tab 키 기본 동작 방지
          if (show_suggestion.value) {
            show_suggestion.value = false; // Tab 키로 닫기
          } else {
            show_suggestion.value = true; // Tab 키로 열기
          }
          if (filteredExCoverages.value.length > 0) {
            setCoverageNameForAdd(filteredExCoverages.value[temp_sel_suggestion.value].name);
          }
        }
      } else if (event.key === "Enter") {
        event.preventDefault(); // Enter 키 기본 동작 방지
        if (filteredExCoverages.value.length > 0 && temp_sel_suggestion.value != null) {
          addCoverage(filteredExCoverages.value[temp_sel_suggestion.value].idx);
          temp_sel_suggestion.value = null;
        }
      }
    }

    function getPayTypeLabel(code) {
      return {
        0: "년납",
        1: "세납",
        2: "일시납",
        3: "기타(그외)"
      }[code] || "-";
    }

    function getEndTypeLabel(code) {
      return {
        0: "세만기",
        1: "년만기",
        2: "종신",
        3: "기타(그외)"
      }[code] || "-";
    }

    function getTypeTypeLabel(code) {
      const map = {
        0: "직접입력",
        1: "종합보장",
        2: "건강/상해",
        3: "단독실손",
        4: "종신/정기",
        5: "연금/저축",
        6: "회사/법인",
        7: "실버/상속",
        8: "자녀/태아",
        9: "운전자",
        10: "치아보험",
        11: "골프/레저",
        12: "주택/건물"
      };

      return map[code] || "기타";
    }

    
    // print_mode.value = false;
    // function printSolution() {
    //   print_mode.value = true;
    //   setTimeout(() => {
    //     window.print();
    //     print_mode.value = false;
    //   }, 100);
    // }
    

    function printSolution(mode = 'card') {
      printMode.value = mode;
      
      setTimeout(() => {
        const root = document.documentElement;
        const prevTitle = document.title;
        const wasDark = root.classList.contains('dark-mode');

        // 인쇄 시 라이트 모드 강제 적용
        if (wasDark) {
          root.classList.remove('dark-mode');
          root.classList.add('light-mode');
        }

        document.title = solutionInfo.value.name;
        window.onafterprint = () => {
          document.title = prevTitle;
          // 원래 테마 복원
          if (wasDark) {
            root.classList.remove('light-mode');
            root.classList.add('dark-mode');
          }
        };

        window.print();
      }, 100);
    }
    
    // 엑셀 테이블용 축약 타입 레이블
    function getPayTypeShort(code) {
      return { 0: "년", 1: "세", 2: "일시", 3: "" }[code] || "";
    }

    function getEndTypeShort(code) {
      return { 0: "세", 1: "년", 2: "종신", 3: "" }[code] || "";
    }
    
    // 보장명 축약
    function shortenCovName(covName, maxLen = 6) {
      let result = covName;
      
      const replaceMap = {
        '상해사망': '상사',
        '질병사망': '질사',
        '상해후유': '상휴',
        '질병후유': '질휴',
        '일반암': '일반',
        '유사암': '유사',
        '고액암': '고액',
        '상수술': '상수',
        '질수술': '질수',
        '암수술': '암수',
        '뇌혈관': '뇌혈',
        '허혈성': '허혈',
        '상해입원': '상입',
        '질병입원': '질입',
        '간병사용상해': '간병사용(상)',
        '간병사용질병': '간병사용(질)',
        '실손(4.0)': '실손',
        '양성종양진단': '양성종양',
      };
      
      for (const [from, to] of Object.entries(replaceMap)) {
        result = result.replace(from, to);
      }
      
      result = result.trim() || covName;

      // 패턴 매칭 후에도 긴 이름은 잘라내기
      if (result.length > maxLen) {
        result = result.slice(0, maxLen);
      }

      return result;
    }
    
    // 숫자 축약 (엑셀 테이블용)
    // function trimNumber(num) {
    //   if (Number.isInteger(num)) return num.toString();
      
    //   let str = num.toString();
      
    //   if (str.length <= 4) return str;
      
    //   str = str.slice(0, 4);
      
    //   if (str.endsWith('.')) {
    //     str = str.slice(0, -1);
    //   }
      
    //   return str;
    // }
    
    // 엑셀 테이블용 대표값 가져오기
    function getDelegateValues(planFakeIdx, chapterKey) {
      const chapterEnName = chapterMapping[chapterKey];
      if (!chapterEnName) return '';
      
      let values = [];

      if (['cancer', 'brain', 'heart'].includes(chapterKey)) {
        const parentChapter = chapterList.value['three_major'];
        if (parentChapter && parentChapter.list[chapterEnName]) {
          const childChapter = parentChapter.list[chapterEnName];
          const childIdx = childChapter.idx;
          
          const coverages = returnCoverages(planFakeIdx, childIdx);
          coverages
            .filter(c => c.use && !c.is_union && !c.low_show)
            .sort((a, b) => a.no - b.no)
            .forEach(cov => {
              const shortName = shortenCovName(cov.short_name || cov.name) || cov.name?.slice(0, 4) || '';
              const classes = [cov.style_bold ? 'bold' : '', cov.style_important ? 'important' : ''].filter(Boolean).join(' ');
              values.push(classes ? `<span class="${classes}">${shortName}: ${formatMoneyToKor(cov.value)}</span>` : `${shortName}: ${formatMoneyToKor(cov.value)}`);
            });
        }
      } else {
        const chapter = chapterList.value[chapterEnName];
        if (!chapter) return '';

        Object.values(chapter.list).forEach(child => {
          const coverages = returnCoverages(planFakeIdx, child.idx);
          coverages
            .filter(c => c.use && !c.is_union && !c.low_show)
            .sort((a, b) => a.no - b.no)
            .forEach(cov => {
              const shortName = shortenCovName(cov.short_name || cov.name) || cov.name?.slice(0, 4) || '';
              const classes = [cov.style_bold ? 'bold' : '', cov.style_important ? 'important' : ''].filter(Boolean).join(' ');
              values.push(classes ? `<span class="${classes}">${shortName}: ${formatMoneyToKor(cov.value)}</span>` : `${shortName}: ${formatMoneyToKor(cov.value)}`);
            });
        });
      }

      return values.length > 0 ? values.join('<br>') : '';
    }

    const tempDateForWheel = ref(null);
    const dateInputTarget = ref(null);
    function useDatePicker(b, event) {
      datePickerShow.value = b;

      // 이벤트 디버깅
      console.log('event.target:', event?.target)

      const target = event?.target
      if (target instanceof HTMLInputElement) {
        dateInputTarget.value = target
        tempDateForWheel.value = target.value;
      } else {
        console.warn('event.target이 <input>이 아닙니다:', target)
        dateInputTarget.value = null
      }
    }


    function handleDateSubmit({ year, month, day }) {
      const inputEl = dateInputTarget.value
      if (inputEl instanceof HTMLInputElement) {
        const mm = String(month).padStart(2, '0')
        const dd = String(day).padStart(2, '0')
        inputEl.value = `${year}-${mm}-${dd}`
        inputEl.dispatchEvent(new Event('input'))
      } else {
        console.warn('날짜를 설정할 대상 input이 없습니다')
      }

      // ✅ 값 반영 후에 닫기
      useDatePicker(false)
    }

    // 푸터 오픈
    function openFooter() {
      const footer = document.querySelector('.footer');
      if (footer) {
        footer.classList.toggle('open');
        footer.classList.toggle('closed');
      }
    }

    function cal_vis_responser(coverage) {
      
      if (coverage.cal_vis == 1) {
        coverage.use = 1;
        coverage.calculable = 1;
      } else {
        coverage.use = 0;
        coverage.calculable = 0;
      }

      mergePlansCoverages();
    }

    const resultCovsByChapter = ref({});

    async function mergePlansCoverages() {
      let plans = solution.value.plan_list;
      const merged = {};
      
      await plans.forEach(plan => {
        Object.entries(plan.coverages).forEach(([chapterIdx, chapter]) => {
          // merged에 챕터가 없다면 챕터 생성
          if (!merged[chapterIdx]) { merged[chapterIdx] = { name: chapter.name, items: {} }; }
          
          // mid chapter 분리
          chapter.forEach((mid_chapter) => {
            if (mid_chapter && mid_chapter.name && mid_chapter.idx !== undefined) {
              const key = mid_chapter.name; // 이름으로 그룹핑
              
              if (!merged[chapterIdx].items[key]) { merged[chapterIdx].items[key] = { idx: mid_chapter.idx, name: mid_chapter.name, list: [] }; }
              
              let orderedList = orderedCoverages(plan.fake_idx, mid_chapter.idx)

              // list 배열의 항목들을 합산
              if (orderedList && orderedList.length > 0) {
                orderedList.forEach(coverage => {

                  if (!coverage.is_union) { return; } // 계산 가능 ? 대표임 ? 필터
                  merged[chapterIdx].items[key].list.push({...coverage});

                  // const existingIdx = merged[chapterIdx].items[key].list.findIndex( c => c.name === coverage.name );  // 중복찾기
                  // if (existingIdx >= 0) {
                  //   // 이미 있으면 금액 합산
                  //   const existing = merged[chapterIdx].items[key].list[existingIdx];
                  //   existing.value = (parseFloat(existing.value) || 0) + (parseFloat(coverage.value) || 0);
                  // } else {
                  //   // 없으면 새로 추가
                  //   merged[chapterIdx].items[key].list.push({...coverage});
                  // }
                });
              }
            }
          });
        });
        resultCovsByChapter.value = merged
        console.log('GOD DAMMMMM',merged);
      });
      
      // 배열 형태로 변환 (원본 구조와 유사하게)
      const result = Object.entries(merged).map(([chapterIdx, chapter]) => {
        return {
          chapterIdx: Number(chapterIdx),
          name: chapter.name,
          items: Object.values(chapter.items)
        };
      });
      
      return result;
    }

    const mergedCovsByChapter = computed(() => {
      const result = {};
      for (const chapterKey in chapterList.value) {
        const chapter = chapterList.value[chapterKey];
        const covsMap = new Map();

        Object.values(chapter.list).forEach(chapterChild => {
          const covs = coverageList.filter(c => c.chapter_idx == chapterChild.idx);

          covs.forEach(cov => {
            const key = cov.original_idx || cov.name || cov.idx;
            if (covsMap.has(key)) {
              const existing = covsMap.get(key);
              covsMap.set(key, {
                ...existing,
                value: (Number(existing.value) || 0) + (Number(cov.value) || 0)
              });
            } else {
              covsMap.set(key, { ...cov });
            }
          });
        });

        result[chapter.idx] = Array.from(covsMap.values());
      }
      return result;
    });


    function getSolutionPrice() {
      let price = 0;
      solution.value.plan_list.forEach(plan => {
        price += Number(plan.price);
        console.log(plan);
      });
      return price;
    }


    const alert_show = ref(false);
    async function showAlert(b) {
      if (b) {
        // 저장 후 닫기
        await saveSolution();
        await props.reload();
        props.closeFunction(false);
      } else {
        // 저장 안하고 닫기
        alert_show.value = true;
      }
    }

    async function exitExecute(type) {
      alert_show.value = false;
      if (type == 0) {
        props.closeFunction(false); // 그냥 닫기
      } else if (type == 1) {
        await saveSolution();
        await props.reload();
        props.closeFunction(false);// 저장 후 닫기
      } else {
        console.error('알 수 없는 종료 타입:', type);
        return;
      }
    }

    async function downloadPlan(ori_plan) {

      const plan = JSON.parse(JSON.stringify(ori_plan));
      // 시스템 로딩 표시
      system_show_info.value = {
        title: "플랜 다운 중 ...",
        text: "종료 시 내용이 저장되지 않을 수 있습니다!"
      };
      system_show.value = true;

      console.log('플랜 다운로드 시작:', plan);

      // 플랜 SQL 생성
      const sql = `INSERT INTO IS_plan SET 
              mb_id = '${member_info.mb_id}', 
              name = '${plan.name}', 
              number = ${plan.no || 0}, 
              pay = '${plan.pay}', 
              pay_type = '${plan.pay_type || ''}', 
              end = '${plan.end}', 
              end_type = '${plan.end_type || ''}', 
              price = '${plan.price}', 
              type = '${plan.type}', 
              type_id = ${plan.type_id || 0}, 
              renewable = ${plan.renewable || 0}, 
              worth = ${plan.worth || 0}, 
              return_worth = ${plan.return_worth || 0}, 
              remarks = '${plan.remarks}', 
              joined_at = ${plan.joined_at ? `'${plan.joined_at}'` : 'NULL'}, 
              sub_type = '${plan.sub_type}', 
              company = '${plan.company}',
              fav = '1' `;

              console.log('플랜 SQL:', sql);

      try {
        const result = await sql_query(sql);
        plan.idx = result.insertId;
        console.log(`📦 플랜 ${result} 저장 완료`);

        // 보장 저장도 병렬 호출 안에서
        await saveCoverages(plan).then(() => {
          console.log(`🛡️ 보장 ${coverageList.length}건 저장 완료 (플랜 ${plan.name})`);
          system_show.value = false;
          fetchFavPlans();
        }).catch(error => {
          console.error(`❌ 보장 저장 실패 (플랜 ${plan.name}):`, error);
          system_show.value = false;
        });
        
      } catch (error) {
        console.error(`❌ 저장 실패 (플랜 ${plan.name}):`, error);
      }
    }

    async function loadFavPlan(plan) {

      let ask = confirm('플랜을 불러오시겠습니까?');
      if (!ask) return;
      openDialog(false);
      solution.value.plan_list.push(plan);
    }

    function openFavPlans() {
      dialogSel.value = "fav-plans";
      openDialog(true);
    }

    // 플랜 로드
async function fetchFavPlans() {
  const sql = `SELECT * FROM IS_plan WHERE mb_id = '${member_info.mb_id}' AND fav = '1' ORDER BY number ASC LIMIT 0, 30`;
  const result = await sql_query(sql);

  // 기존 리스트 초기화
  favPlanList.value = [];
  
  // 1. 모든 원본 보장을 미리 불러와서 Map으로 만들기 (한 번만 조회)
  const originals = await sql_query(`SELECT * FROM IS_ex_coverage`);
  const originalMap = new Map(originals.map(o => [o.idx, o]));

  // 2. 모든 플랜별 보장 SELECT 병렬로 수행
  const planTasks = result.map(async (plan) => {
    const coverageSql = `SELECT * FROM IS_coverage WHERE plan_id = ${plan.idx} ORDER BY idx DESC`;
    const coverages = await sql_query(coverageSql);
    return { plan, coverages };
  });

  const allPlanCoverage = await Promise.all(planTasks);

  // 3. 각 플랜과 보장을 리스트에 추가
  for (const { plan, coverages } of allPlanCoverage) {
    let fake_idx = Math.random() * 1000000;
    
    let s_plan = reactive({
      no: plan.number,
      idx: 0,
      fake_idx: fake_idx,
      name: plan.name,
      pay: plan.pay,
      pay_type: plan.pay_type || 0,
      end: plan.end,
      end_type: plan.end_type || 0,
      price: plan.price,
      type: plan.type,
      type_id: plan.type_id || 0,
      sub_type: plan.sub_type,
      joined_at: (plan.joined_at || '').slice(0, 10),
      company: plan.company,
      company_etc: plan.company_etc || '',
      coverages: {},
      renewable: plan.renewable || 0,
      remarks: plan.remarks || '',
      worth: plan.worth || 0,
      return_worth: plan.return_worth || 0,
      fav: plan.fav || 0,
    });

    favPlanList.value.push(s_plan);

    // 보장 추가 (parent는 coverage.parent 사용)
    for (const coverage of coverages) {
      const original = originalMap.get(coverage.original);

      coverageList.push({
        idx: coverage.idx,
        name: coverage.nick || original?.name || '',
        no: original?.no || 9999,
        short_name: coverage.short_name || original?.short_name || '',
        long_name: coverage.long_name || original?.long_name || '',
        chapter_idx: coverage.chapter_id || original?.chapter_id,
        plan_idx: 0,
        plan_fake_idx: fake_idx,
        value: coverage.value,
        parent: coverage.parent || '',
        fold: false,
        showAdd: false,
        use: coverage.visible || false,
        calculable: coverage.calculable || false,
        cal_vis: (coverage.calculable || coverage.visible) ? 1 : 0,
        visible: true,
        description: original?.description || '',
        showDescription: false,
        searchable: coverage.searchable || false,
        suggestion: coverage.suggestion || false,
        style_bold: original?.style_bold || 0,
        style_important: original?.style_important || 0,
        original_idx: coverage.original,
        linked_ref: original?.linked_ref || '',
        period_value: coverage.period_value || 0,
        period_type: coverage.period_type || '세',
        renewable: coverage.renewable || 0,
        premium: coverage.premium || 0,
        is_union: coverage?.is_union || 0,
        low_show: coverage?.low_show || 0,
      });
    }
  }
  addCoverageToSolution()
}

fetchFavPlans();

    const showCompanyPicker = ref(false);

    function ToggleCompanyPicker(bool) {
      showCompanyPicker.value = bool;
    }

    function handleCompanySubmit(company) {
      ToggleCompanyPicker(false);
      if(company == null || !editingPlan.value) {
        console.error('❌ handleCompanySubmit: Invalid company object:', company);
        return;
      }
      editingPlan.value.company = company?.value;
    }

    function filteredExCoveragesForSub(parentCov) {
      const baseList = IS_ex_coverages.value;
      return baseList
        .filter(cov => 
          cov.parent == parentCov.original_idx
        )
        .sort((a, b) => a.no - b.no);
    }

    function covMouseHoverSt(cov) {
      hoverTimer.value = setTimeout(() => {
        console.log('1초 동안 hover했습니다!');
        cov.showDescription = true;
      }, 1000);
    }

    function covMouseLeaveSt(cov) {
      if (hoverTimer.value) {
        clearTimeout(hoverTimer.value);
        hoverTimer.value = null;
        cov.showDescription = false;
      }
    }

    onBeforeUnmount(() => {
      if (hoverTimer.value) {
        clearTimeout(hoverTimer.value);
        hoverTimer.value = null;
      }
    });

    function getResultFromUnionsChild(union) {
      // children이 배열인지 확인
      if (!union || !Array.isArray(union.children)) { console.log('getResultFromUnionsChild ERROR', union); return 0; }

      let result = 0;

      for (const child of union.children) {
        if (child.calculable === 1) {
          result += Number(child.value || 0);
        }
      }

      return result;
    }


    function formatMoneyToKor(money) {
      // money 단위: 만원 (1 = 1만원)
      
      if (money >= 10000) {
        // 억 단위
        const eok = Math.round(money / 10000);
        return `${eok}억`;
      } else if (money >= 1000) {
        // 천 단위
        const cheon = Math.round(money / 1000);
        return `${cheon}천`;
      } else if (money >= 100) {
        // 백 단위
        const baek = Math.round(money / 100);
        return `${baek}백`;
      } else {
        // 100 미만은 그냥 만원 단위로
        return `${money}만`;
      }
    }

    return {
      solutionInfo,
      sql_query,
      chapterList,
      fetchChapter,
      foldOpenByKey,
      solution,
      getInsuCompanyInfo,
      returnCoverages,
      returnCoverageTotalValue,
      makePlan,
      deletePlan,
      saveSolution,
      dialogOpen,
      dialogSel,
      openDialog,
      editPlan,
      editingPlan,
      insuCompanys,
      editCoverage,
      editingChapter,
      getChapterByIdx,
      orderedCoverages,
      editCoverageFold,
      deleteCoverage,
      addChildCoverage,
      addCoverage,
      CoverageNameForAdd,
      CoverageValueForAdd,
      filteredExCoverages,
      show_suggestion,
      onFocus,
      onBlur,
      editingChapterParent,
      planFav,
      getHiddenCount,
      getHiddenCountByChapter,
      dialog_editing_cov,
      showEditCovDialog,
      editingCoverage,
      planUpDown,
      getChapterChild,
      getChapterParentByIdx,
      setCoverageNameForAdd,
      getRenewableLabel,
      formatMoney,
      system_show,
      system_show_info,
      editingPlanForCov,
      modal_show,
      modalOpen,
      modal_editing_choseChapter,
      selectChapterToMoveCov,
      askChapterToMoveCov,
      getCovsInChapter,
      openReference,
      changeShowType,
      showingReference,
      updateCovNameForAdd,
      suggestionMove,
      temp_sel_suggestion,
      getPayTypeLabel,
      getEndTypeLabel,
      getTypeTypeLabel,
      getSortedChildren,
      print_mode,
      printMode,
      printSolution,
      showPrintMenu,
      getDelegateValues,
      getPayTypeShort,
      getEndTypeShort,
      shortenCovName,
      useDatePicker,
      datePickerShow,
      handleDateSubmit,
      tempDateForWheel,
      showSolutionInfoEdit,
      editingSolutionForInfo,
      editSolutionInfo,
      reloadSolutionInfo,
      openFooter,
      mergedCovsByChapter,
      getSolutionPrice,
      showAlert,
      alert_show,
      exitExecute,
      downloadPlan,
      openFavPlans,
      favPlanList,
      loadFavPlan,
      member_info,
      halfLettering,
      basic_profile_url,
      genderChoser,
      calculateInsuAge,
      handleRatingSubmit,
      defRateValue,
      showRatingView,
      ratingSolution,
      showCompanyPicker,
      handleCompanySubmit,
      ToggleCompanyPicker,
      watchingPost,
      resultCovsByChapter,
      mergePlansCoverages,
      cal_vis_responser,
      show_sub_suggestion,
      CoverageNameForAddSub,
      CoverageValueForAddSub,
      onSubFocus,
      onSubBlur,
      filteredExCoveragesForSub,
      covMouseHoverSt,
      covMouseLeaveSt,
      getResultFromUnionsChild,
      showMore,
      showMoreToggle,
      nowNewAddCovTemp,
      formatMoneyToKor,
      connectedCustomer,
      tempEdCovSelChap,
      showFeedbackDialog,
      feedbackList,
      requestFeedback,
      showFeedbackHistory,
      viewFeedbackAnnotations,
      viewComparisonSolution,
      selectedSolution,
      showViewDialog,
      closeViewDialog,
    };
  },
}
</script>

<style>

  body {
    height: fit-content !important;   /* 실제 내용이 클 경우 */
  }

</style>

<style scoped>

#module-CA-detail {
  position:absolute;
  left:0;
  top:0;
  z-index:10000;
  width: 100%;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 24px;
  background-color: var(--color-background);
}

#module-CA-detail.CA_A {
  --tranditanl-color:var(--color-ca-a);
  --tranditanl-color-light:var(--color-ca-a-light);
}

#module-CA-detail.CA_B {
  --tranditanl-color:var(--color-ca-b);
  --tranditanl-color-light:var(--color-ca-b-light);
}

@media print {
  #module-CA-detail {
    zoom: 110%; /* 인쇄 시 확대 */
    padding:0 !important;
    padding-bottom:120px !important;
    box-sizing:border-box !important;
    gap:12px;
    min-height: 100vh; /* 추가 */
  }

  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  .add-btn { display: none !important; }
  .chart > .plan > .coverage-list .none { display:none !important; }

  /* Footer를 인쇄 시 static으로 변경 */
  .footer {
    position: relative !important; /* fixed → static */
    bottom: 12px !important;
    height: fit-content !important;
    max-height: none !important;
    padding: 6px !important;
    box-sizing: border-box !important;
    box-shadow: none !important;
    background: var(--tranditanl-color-light) !important;
    border-radius: 12px !important;
    border: 1px solid var(--color-text-secondary) !important;
    gap: 12px !important;
    flex-direction: column;
    justify-content: center;
    page-break-inside: avoid; /* 추가: 페이지 나눔 방지 */
    margin-top: 24px !important; /* 추가: 위 여백 */
  }
  /* Footer의 ul만 숨김 */
  .footer > ul {
    display: none !important;
  }

  .footer > .open_btn {
    display: none !important;
  }

  .footer > .short {
    padding: 12px 16px !important;
  }
  .main-header { padding: 0 !important; height:24px !important; margin-bottom:12px !important; margin-top:16px !important; }
  .main-header h2 { font-size:18px!important; }
  .main-header > div { gap:12px; }
  .main-header img { width:24px !important; height:24px !important; }
  .main-header > p { display:none !important;}
  .header { justify-content: end !important; }
  .header > .right { display: none !important; }
  .header > div > div { border:none !important; }
  .header { height:36px !important; position: absolute !important; left:0px; top:14px; }
  .chart > .plan > .plan-info { height:36px !important; padding:2px !important; gap:4px !important; background: var(--tranditanl-color); -webkit-print-color-adjust:exact;}
  .chart {
    height: fit-content !important;
    max-height: none !important;
    overflow: visible !important;
    -webkit-overflow-scrolling: auto !important;
    padding-bottom: 0 !important; /* 200px 제거 */
  }
  .chart > .plan > .plan-info { border:1px solid var(--color-text-secondary) !important; border-bottom:none; break-after: page; }
  .contents > .chapter { height:30px !important; background-color:var(--tranditanl-color); }
  .contents > .chapter > h2 { font-size:12px!important; }
  .contents { border:1px solid var(--color-text-secondary); border-radius:12px !important; }
  .chart > .plan > .coverage-list > .coverage > .list > ul > li { font-size: var(--font-size-lg) !important; }
  .chart > .plan > .coverage-list > .coverage > .list { padding-bottom:24px !important; }
  .chart > .plan > .plan-info > ul > li > img { display:none !important; }
  .chart > .plan > .plan-info > ul > li > span, h2 { font-size:12px !important; }
  .control { display: none !important; }
  #print_only { display: flex; }
  #etc-notice-sp { position: absolute; top: 10%; right: 5mm; font-size:20px; display:block; }
  
  .chart {
    height:fit-content !important;
    max-height:none !important;
    overflow: visible !important;
    -webkit-overflow-scrolling: auto !important;
  }
  .chart > .plan {
    background: var(--tranditanl-color) !important;
    break-inside: avoid;
    page-break-inside: avoid;
    position: relative !important;
    height:fit-content !important;
    overflow:visible !important;
    display:flex !important;
    flex-direction: column !important;
    justify-content: start !important;
    padding-top: 32px !important;
    border-radius: 12px !important;
  }
  .plan-info { display:flex !important; position:absolute !important; top:0 !important; border-radius:12px 12px 0px 0px; }
  .plan-info > ul > li > img { width:36px !important; height:36px !important; }
  .coverage-list { overflow:visible !important;  border-radius:0px 0px 12px 12px !important; }
}

@page {
  size: A4 landscape;
  padding:0.6cm !important;
}

#print_only {
  width:100%;
  height:100%;
  position: absolute;
  left:0;
  top:0;
  background-color: var(--color-background);
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  z-index: 999;
  backdrop-filter: blur(12px);
  padding:16px;
  box-sizing: border-box;
}

#print_only > h1 {
  width:100%;
  text-align: center;
  font-size: var(--font-size-xl);
  color: var(--color-text-primary);
  margin:0;
  padding:0;
}


#description-viewer {
  position:absolute;
  top:-50px;
  left:30%;
  width:fit-content;
  max-width:50%;
  height:fit-content;
  padding:12px;
  font-size:var(--font-size-sm);
  background: var(--tranditanl-color-light);
  z-index:99;
  display:flex;
  flex-direction:column;
  gap:12px;
  border-radius: 12px;
  backdrop-filter: blur(6px);
}

#description-viewer > h2 {
  font-size:var(--font-size-base);
  padding:0;
  margin:0;
}

#description-viewer > span {
  font-size:var(--font-size-base);
  white-space: pre-line;
}


.system { 
  width:100%;
  height:100%;
  position: absolute;
  left:0;
  top:0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99;
  gap:16px;
  backdrop-filter: blur(12px);
}

.system > img {
  width: 50%;
  height: auto;
  aspect-ratio: 1 / 1;
  max-width:300px;
  object-fit: contain;
}

.system > h2 {
  width:100%;
  text-align: center;
  font-size: var(--font-size-xl);
  color: var(--color-text-primary);
}

.system > span {
  width:100%;
  text-align: center;
  font-size: var(--font-size-md);
  color: var(--color-text-primary);
}

.reference { 
  width:100%;
  height:100%;
  position: absolute;
  left:0;
  top:0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99;
  gap:16px;
  backdrop-filter: blur(12px);
}

.reference > .cls {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: -1;
}

.reference > .paper {
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  height: fit-content;
  background: var(--tranditanl-color);
  border-radius: 16px;
  padding: 24px 16px;
  box-sizing: border-box;
  gap:24px;
  display:flex;
  flex-direction: column;
  align-items: center;
}

.reference > .paper > img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.dialog {
  width:100%;
  height:100%;
  position: absolute;
  left:0;
  top:0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
}

.dialog > .close {
  position: absolute;
  z-index: -1;
  right: 0;
  top: 0;
  width:100%;
  height:100%;
}

.dialog > .paper {
  position: relative;
  width: 100%;
  max-width:600px;
  height: 80%;
  background-color: var(--color-background);
  border:1px solid var(--color-text-primary);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  overflow:scroll;
}

.dialog > .paper::-webkit-scrollbar {
  display: none;
}

.dialog > .paper > .header {
  width:100%;
  height:48px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-lg);
}

.dialog > .paper > .header > h1 {
  font-size:20px;
}

.dialog > .paper > .header > span {
  width:48px;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

.dialog > .paper > div > h2 {
  font-size: var(--font-size-md);
}

.dialog > .paper > div > ul {
  width:100%;
  list-style: none;
  margin:0;
  padding:0;
  gap:16px;
  display:Flex;
  flex-direction: column;
}

.dialog > .paper > div > ul > li {
  width:100%;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:12px;
}

.dialog > .paper > div > ul > li > input[type="text"] {
  width:100%;
  height:36px;
  border-radius:6px;
  border:none;
  padding:0 12px;
  box-sizing: border-box;
  background: var(--tranditanl-color-light);
}

.dialog > .paper > div > ul > li.plus {
  width:100%;
  height:36px;
  display:flex;
  justify-content: center;
  align-items: center;
  border-radius:6px;
  border:1px solid var(--color-text-primary);
  cursor:pointer;
}

.dialog .paper.edit-coverage .modal {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99;
  backdrop-filter: blur(2px);
}

.fav-plans > ul {
  width:100%;
  height:100%;
  list-style: none;
  margin:0;
  padding:0;
  display:flex;
  flex-direction: column;
  gap:12px;
}

.fav-plans > ul > li {
  width:100%;
  height:60px;
  display:flex;
  justify-content: start;
  align-items: center;
  gap:12px;
  border-radius:6px;
  background:var(--tranditanl-color);
  cursor:pointer;
  overflow:hidden;
  border:1px solid var(--color-background);
}

.fav-plans > ul > li:hover {
  border:1px solid var(--tranditanl-color-light);
}

.fav-plans > ul > li > img {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.dialog .paper.edit-coverage .modal > .paper {
  width: 90%;
  height: fit-content;
  background: var(--tranditanl-color);
  border-radius: 16px;
  padding: 24px 16px;
  box-sizing: border-box;
  gap:24px;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.dialog .paper.edit-coverage .modal > .paper > .cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog .paper.edit-coverage .modal > .paper > h2 {
  width:100%;
  text-align: center;
  font-size: var(--font-size-lg);
  font-weight:600;
  margin:0;
  margin-bottom:24px;
}

.dialog .paper.edit-coverage .modal > .paper > button {
  width:100%;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:12px;
  border:1px solid var(--tranditanl-color-light);
  border-radius:6px;
  font-size: var(--font-size-lg);
  cursor:pointer;
  background: var(--color-brand);
  color: var(--color-text-black);
}

.dialog .paper.edit-coverage .modal > .paper > ul {
  width:100%;
  list-style: none;
  margin:0;
  padding:0;
  gap:16px;
  display:Flex;
  flex-direction: row;
}

.dialog .paper.edit-coverage .modal > .paper > ul > li {
  width:100%;
  height:36px;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:12px;
  border:1px solid var(--tranditanl-color-light);
  border-radius:6px;
  font-size: var(--font-size-md);
  cursor:pointer;
}

.dialog .paper.edit-coverage .modal > .paper > ul > li:hover {
  background: var(--tranditanl-color-light);
}

.dialog .paper.edit-coverage .editing {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99;
  backdrop-filter: blur(2px);
}

.dialog .paper.edit-coverage .editing .cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog .paper.edit-coverage .editing .page {
  width: 90%;
  height: fit-content;
  background: var(--tranditanl-color);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap:24px;
  display:flex;
  flex-direction: column;
}

.dialog .paper.edit-coverage .editing .page > .header {
  width:100%;
  height:48px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-lg);
}

.dialog .paper.edit-coverage .editing .page > .header > h2 {
  font-size:20px;
}

.dialog .paper.edit-coverage .editing .page > .header > span {
  width:48px;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

.dialog .paper.edit-coverage .editing .page > .concepts-double.option {
  background:var(--color-background);
  padding:12px;
  box-sizing:border-box;
  border-radius:6px;
}

.dialog .paper.edit-coverage .editing .page > .concepts-double {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: row;
  gap:24px;
}

.dialog .paper.edit-coverage .editing .page > .concepts-double > div {
  position:relative;
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  gap:12px;
  flex:1;
}

.dialog .paper.edit-coverage .editing .page > .concepts-double > div .moneySize {
  padding:0;
  margin:0;
  position:absolute;
  right:8px;
  bottom:8px;
  font-size:var(--font-size-md);
}

.dialog .paper.edit-coverage .editing .page > .concepts-double > div.forCheck {
  display:flex;
  justify-content: start;
  align-items: center;
  flex-direction: row;
}

.dialog .paper.edit-coverage .editing .page span {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: center;
  align-items: center;
  padding:6px;
  box-sizing: border-box;
  border-radius:6px;
  cursor:pointer;
}

.dialog .paper.edit-coverage .editing .page input[type="text"],
.dialog .paper.edit-coverage .editing .page input[type="number"],
.dialog .paper.edit-coverage .editing .page select {
  width:100%;
  height:36px;
  border-radius:6px;
  border:none;
  padding:0 12px;
  box-sizing: border-box;
  border:1px solid var(--tranditanl-color-light);
  background-color: var(--color-background);
}

.dialog .paper.edit-coverage .editing .page > .btns {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:12px;
}

.dialog .paper.edit-coverage .editing .page > .btns > button.confirm {
  background: var(--color-brand);
  color: var(--color-text-black);
}

.dialog .paper.edit-coverage .editing .page > .btns > button {
  width:100%;
  height:36px;
  background: var(--tranditanl-color-light);
  color: var(--color-text-primary);
  border-radius:6px;
  border:none;
  font-size:var(--font-size-base);
  font-weight:600;
  cursor:pointer;
}

.dialog .paper.edit-coverage .all {
  display: none;
}

.dialog .paper.edit-coverage .suggestion {
  position: absolute;
  bottom:64px;
  width: 40%;
  height: fit-content;
  max-height:300px;
  overflow-y: scroll;
  display:flex;
  flex-direction: column;
  gap: 6px;
  padding:12px;
  box-sizing: border-box;
  background: var(--tranditanl-color);
  border-radius: 8px;
  z-index: 999;
}

.dialog .paper.edit-coverage .suggestion > span {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: center;
  align-items: center;
  padding:6px;
  box-sizing: border-box;
  border-radius:6px;
  cursor:pointer;
}

.dialog .paper.edit-coverage .suggestion > span:hover,
.dialog .paper.edit-coverage .suggestion > span.selected {
  background: var(--tranditanl-color-light);
}

.dialog .paper.edit-plan {
  width:100%;
  display:flex;
  flex-direction: column;
  gap:24px;
}

.dialog .paper.edit-plan > .double {
  width:100%;
  display:flex;
  align-items: center;
  gap:16px;
}
.dialog .paper.edit-plan .double > button {
  min-width:fit-content;
  height:fit-content;
  padding:6px 8px;
  box-sizing: border-box;
}

.dialog .paper.edit-plan .item.double {
  width:100%;
  display:flex;
  align-items: end;
  flex-direction:row !important;
  gap:16px;
}

.dialog .paper.edit-plan .item.double button {
  height:36px;
  background:var(--tranditanl-color);
  border:none;
  border-radius:6px;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:0 6px;
  box-sizing: border-box;
  font-size:var(--font-size-md);
}

.dialog .paper.edit-plan .item.double .company-name {
  display:flex;
  align-items:center;
  justify-content:start;
  width:100%;
  height:36px;
  border-radius:6px;
  border:none;
  padding:0 6px;
  box-sizing: border-box;
  background: var(--tranditanl-color);
  font-size:var(--font-size-md);
}

.dialog .paper.edit-plan .item {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  gap:6px;
}


.dialog .paper.edit-plan .item > p {
  padding:0;
  margin:0;
  font-size: var(--font-size-md);
}

.dialog .paper.edit-plan .item > input[type="text"],
.dialog .paper.edit-plan .item > input[type="number"],
.dialog .paper.edit-plan .item > input[type="date"],
.dialog .paper.edit-plan .item > textarea {
  width:100%;
  height:36px;
  border-radius:6px;
  border:none;
  padding:0 6px;
  box-sizing: border-box;
  background: var(--tranditanl-color);
  font-size:var(--font-size-md);
}

.dialog .paper.edit-plan .item > select {
  width:100%;
  height:36px;
  border-radius:6px;
  border:none;
  padding:0 6spx;
  box-sizing: border-box;
  background: var(--color-background);
  border:1px solid var(--tranditanl-color-light);
  font-size:var(--font-size-md);
}


.dialog .paper.edit-plan > .btns {
  width:100%;
  height: 36px;
  box-sizing: border-box;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:12px;
  background:var(--color-background);
}

.dialog .paper.edit-plan > .btns > button {
  width:100%;
  height:36px;
  box-sizing: border-box;
  background:var(--tranditanl-color-light);
  color: var(--color-text-primary);
  border-radius:6px;
  border:none;
  font-size: var(--font-size-md);
  font-weight:600;
  cursor:pointer;
}
.dialog .paper.edit-plan > .btns > button.save {
  background:var(--color-brand);
  color: var(--color-text-white);
} 

.dialog .paper.edit-coverage {
  width:100%;
  height:80%;
  flex:1;
  display:flex;
  flex-direction: column;
  gap:12px;
  overflow:hidden !important;
}

.dialog .paper.edit-coverage > .foot {
  width:100%;
  display:flex;
  gap:16px;
}

.dialog .paper.edit-coverage > .foot > div {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:6px;
  background: var(--tranditanl-color-light);
  border-radius: 6px;
  overflow:hidden;
  padding-right:6px;
  box-sizing: border-box;
}

.dialog .paper.edit-coverage > .foot > div > input {
  width:50%;
  background: none;
  flex:1;
  height:36px;
  border:none;
  padding:0px;
  padding-left: 12px;
  box-sizing: border-box;
}

.dialog .paper.edit-coverage > .foot > div > input[type="number"] {
  text-align: right;
}

.dialog .paper.edit-coverage > .foot > div > input:focus {
  outline:none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.dialog .paper.edit-coverage > .foot > div > span {
  width:fit-content;
  height:36px;
  display:flex;
  justify-content: center;
  align-items: center;
  padding:0 0px;
  box-sizing: border-box;
}

.dialog .paper.edit-coverage > .foot > button {
  width:120px;
  height:36px;
  background: var(--color-brand);
  color: var(--color-text-black);
  border-radius:6px;
  border:none;
  font-size:var(--font-size-base);
  font-weight:600;
  cursor:pointer;
}

.dialog .paper.edit-coverage > .cov-editor {
  width:100%;
  height:100%;
  flex:1;
  display:flex;
  flex-direction: column;
  gap:48px;
  overflow-y: scroll;
}

.dialog .paper.edit-coverage > .cov-editor::-webkit-scrollbar {
  display: none;
}

.dialog .paper.edit-coverage > .cov-editor .mother {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap:16px;
}

.dialog .paper.edit-coverage > .cov-editor .mother > h2 {
  width:100%;
  height:100%;
  display:flex;
  justify-content: space-between;
  align-items: center;
  margin:0;
  padding:0;
  font-size: var(--font-size-lg);
  gap:12px;
  background: var(--tranditanl-color-light);
  border-radius: 16px;
  padding:12px;
  box-sizing: border-box;
}

.dialog .paper.edit-coverage > .cov-editor .mother > h2 > span {
  display:flex;
  justify-content: center;
  align-items: center;
  gap:6px;
}

.dialog .paper.edit-coverage > .cov-editor ul {
  width:100%;
  height:fit-content;
  flex:1;
  list-style: none;
  margin:0;
  padding:0;
  display:flex;
  flex-direction: column;
  gap:12px;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  gap:12px;
  padding:0px 12px;
  box-sizing: border-box;
  border-radius:6px;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage button {
  width:30px;
  height:30px;
  border-radius:6px;
  background:none;
  display:flex;
  justify-content: center;
  align-items: center;
  border:1px solid var(--color-text-primary);
  cursor: pointer;
  font-size:var(--font-size-md);
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div {
  width:100%;
  height:fit-content;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div span {
  font-size: var(--font-size-md);
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div span.wide {
  flex:1;
  display:flex;
  justify-content: start;
  align-items: center;
  font-size: var(--font-size-md);
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.info {
  position:relative;
  display:flex;
  justify-content: start;
  align-items: center;
  gap:12px;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.child-list {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  gap:12px;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.child-list > div {
  position:relative;
  display:flex;
  justify-content: start;
  align-items: center;
  gap:12px;
  color:var(--color-text-primary);
  font-weight:200;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.child-list > div > span {
  opacity:0.6;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage input[type="checkbox"] {
  width:18px;
  height:18px;
  cursor:pointer;
  padding:12px;
  margin:0;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.child-list > div.add {
  display:flex;
  position:relative;
  padding-left:36px;
  height:30px;
  gap:6px;
  align-items: center;
  justify-content: start;
  opacity:1;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.child-list > div.add > span {
  font-size:20px;
  opacity:1;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.child-list > div.add > span small {
  font-size: var(--font-size-base);
  opacity:0.6;
  text-decoration: underline;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.child-list > div.add > input {
  width:60%;
  height:30px;
  border-radius:6px;
  border:1px solid var(--color-text-primary);
  padding:0 12px;
  box-sizing:border-box;
  background:var(--color-background);
  font-size: var(--font-size-md);
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.child-list > div.add > ul {
  left:60px;
  top:36px;
  width:50%;
  max-height:260px;
  overflow-y: scroll;
  position: absolute;
  background:var(--tranditanl-color);
  color:var(--color-text-primary);
  list-style: none;
  border-radius:12px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
  z-index:99;
  gap:0;
  display:flex;
  flex-direction: column;
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.child-list > div.add > ul > li {
  cursor:pointer;
  padding:12px;
  box-sizing:border-box;
  border-radius:6px;
  font-size: var(--font-size-md);
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.child-list > div.add > ul > li:hover {
  background: var(--tranditanl-color-light);
}

.dialog .paper.edit-coverage > .cov-editor ul > li.coverage > div.child-list > div.add > button {
  width:30px;
  height:30px;
  border:none;
  background:var(--color-brand);
  border-radius: 6px;
  color:black;
}

.header { 
  display:flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height:48px;
}

.header > div {
  display: flex;
  align-items: center;
  gap: 16px;
  width:fit-content;
  height:100%;
  gap:12px;
}

.header > div > div {
  display:flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding:12px;
  box-sizing: border-box;
  border:1px solid var(--color-text-secondary);
  border-radius: 6px;
  gap:6px;
  font-size: var(--font-size-md);
  font-weight: 700;
}

.header > div > div > img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}

.header > div > button {
  display:flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: 100%;
  padding: 0 24px;
  background: none;
  border:1px solid var(--tranditanl-color-light);
  color: var(--color-text-primary);
  border-radius: 6px;
  font-size: var(--font-size-md);
  font-weight: 600;
  cursor: pointer;
  gap:6px;
}

.chart {
  width:100%;
  height:100%;
  max-height:76%;
  padding-bottom:200px;
  flex:1;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  gap:24px;
  overflow:scroll;
  -webkit-overflow-scrolling: touch;
}

.chart::-webkit-scrollbar {
  display: none;
}

.chart > .add-btn {
  width:100%;
  min-height:90px;
  display:flex;
  justify-content: start;
  align-items: center;
  background: var(--tranditanl-color);
  color: var(--color-text-primary);
  border-radius:6px;
  gap:12px;
  font-size: var(--font-size-xl);
  font-weight:600;
  cursor:pointer;
  border:none;
  border-radius:16px;
  padding:24px;
  box-sizing: border-box;
  margin:0;
  transition: all 0.1s ease-in-out;
}

.chart > .add-btn:hover {
  background: var(--tranditanl-color-light);
}

.chart > .plan {
  width:100%;
  min-height:fit-content;
  height:fit-content;
  display:flex;
  flex-direction: column;
  border-radius:16px;
  overflow:hidden;
  background:var(--tranditanl-color);
  border-radius:16px;
}

.chart > .plan > .plan-info {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: space-between;
  align-items: center;
  gap:8px;
  padding:12px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--tranditanl-color-light);
}

.chart > .plan > .plan-info > .control {
  width:fit-content;
  height:100%;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:12px;
}

.chart > .plan > .plan-info > .control > p {
  width:36px;
  height:36px;
  display:flex;
  justify-content: center;
  align-items: center;
  border-radius:6px;
  border:1px solid var(--color-text-primary);
  cursor:pointer;
  padding:0;
  margin:0;
}

.chart > .plan > .plan-info > .control > .pad {
  display:flex;
  flex-direction: column;
  gap:4px;
}

.chart > .plan > .plan-info > .control > .pad > p {
  width:16px;
  height:16px;
  display:flex;
  justify-content: center;
  align-items: center;
  border-radius:6px;
  cursor:pointer;
  padding:0;
  margin:0;
}

.chart > .plan > .plan-info > h2 {
  height:40px;
  display:flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-lg);
  font-weight: bold;
  margin:0;
  padding:0;
}

.chart > .plan > .plan-info > ul {
  height:100%;
  display:flex;
  list-style: none;
  margin:0;
  padding:0;
  gap:12px;
  cursor:pointer;
}

.chart > .plan > .plan-info > ul > li {
  width:fit-content;
  display:flex;
  justify-content: center;
  align-items: center;
}

.chart > .plan > .plan-info > ul > li > img {
  width:48px;
  height:48px;
  border-radius:6px;
}

.chart > .plan > .plan-info > ul > li h2 {
  font-size: var(--font-size-md);
}

.chart > .plan > .plan-info > ul > li span {
  font-size: var(--font-size-md);
  font-weight:var(--font-weight-extralight);
  color: var(--color-text-primary);
}

.chart > .plan > .coverage-list {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: row;
  box-sizing: border-box;
  border:1px solid var(---tranditanl-color-light);
  border-radius: 0px 0px 16px 16px;
  overflow:hidden;
}

.chart > .plan > .coverage-list .none {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  opacity:0.6;
  font-size:var(--font-size-base);
  display:flex;
  justify-content: center;
  align-items: center;
}

.chart > .plan > .coverage-list > .coverage {
  width:100%;
  display:flex;
  flex:3.2;
}

.chart > .plan > .coverage-list > .coverage.fold {
  flex:1 !important;
}

.chart > .plan > .coverage-list > .coverage.wide {
  flex:3.6;
}

.chart > .plan > .coverage-list > .coverage > .list {
  position:relative;
  width:100%;
  display:flex;
  flex-direction: column;
  flex:1;
  padding:6px;
  box-sizing: border-box;
  border-right:1px solid var(--tranditanl-color-light);
  cursor:pointer;
  transition: all 0.1s ease-in-out;
  padding-bottom:36px;
  box-sizing: border-box;
}

.chart > .plan > .coverage-list > .coverage > .list.folder {
  background: var(--tranditanl-color-light);
}

.chart > .plan > .coverage-list > .coverage > .list:hover {
  background-color: var(--tranditanl-color-light);
}

.chart > .plan > .coverage-list > .coverage:last-child > .list:last-child {
  border-right:none;
}

.chart > .plan > .coverage-list > .coverage > .list > .other {
  position:absolute;
  bottom:0;
  left:0;
  width:100%;
  height:var(--font-size-2xl);
  display:flex;
  justify-content: space-between;
  align-items: center;
  color:var(--color-text-primary);
  padding:6px;
  box-sizing: border-box;
  font-weight:400 !important;
  opacity:0.4;
}

.chart > .plan > .coverage-list > .coverage > .list > .other > span {
  font-size: var(--font-size-base);
}

.chart > .plan > .coverage-list > .coverage > .list > ul {
  width:100%;
  list-style: none;
  margin:0;
  padding: 0;
  display:flex;
  gap:6px;
  flex-direction: column;
}

.chart > .plan > .coverage-list > .coverage > .list > ul > li {
  width:100%;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:4px;
  flex-direction: row;
  box-sizing: border-box;
  border-radius:16px;
  font-size: var(--font-size-md);
  text-align: start;
}

@media (max-width: 1024px) or (max-height: 800px) {
  .chart > .plan > .coverage-list > .coverage > .list > ul > li {
    flex-direction: column;
    align-items: start;
  }
  .chart > .plan > .coverage-list > .coverage > .list > ul {
    gap:16px;
  }
}

.chart > .plan > .coverage-list > .coverage > .list > ul > li > span {
  font-size:var(--font-size-base);
  overflow: hidden;
}

.chart > .plan > .coverage-list > .coverage > .list > ul > li.important {
  /* color:var(--color-special-point); */
  color:var(--color-text-primary);
  opacity:0.5;
}

.chart > .plan > .coverage-list > .coverage > .list > ul > li.bold {
  font-weight: 1000;
}

.chart > .plan > .coverage-list > .coverage > .list > ul > li > span:first-child {
  flex:1;
  display:flex;
  justify-content: start;
  align-items: center;
}

.contents {
  width: 100%;
  min-height:fit-content;
  padding:0;
  margin:0;
  display: flex;
  background-color:var(--tranditanl-color);
  overflow:hidden;
  border-radius:12px;
}

.contents > .chapter {
  width: 100%;
  height: 70px;
  display: flex;
  flex:3.2;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-right:1px solid var(--tranditanl-color-light);
  background-color: var(--tranditanl-color-light);
}

.contents > .chapter.wide {
  flex:3.6 !important;
}

.contents > .chapter:last-child {
  border-right:none;
}

.contents > .chapter.fold {
  flex:1 !important;
  background-color: var(--tranditanl-color);
}

.contents > .chapter > h2 {
  width:100%;
  height:100%;
  flex:1.5;
  display:flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  margin: 0;
  padding: 0px;
  cursor: pointer;
  transition:all 0.1s ease-in-out;
}

.contents > .chapter > h2:hover{
  background-color: var(--tranditanl-color-light);
}

.contents > .chapter > ul {
  width:100%;
  height:100%;
  flex:1;
  list-style: none;
  margin: 0;
  padding: 0;
  display:flex;
  border-top:1px solid var(--tranditanl-color-light);
}

.contents > .chapter > ul > li {
  width:100%;
  display:flex;
  justify-content: center;
  align-items: center;
  flex:1;
  border-right:1px solid var(--tranditanl-color-light);
}

.contents > .chapter > ul > li > span {
  font-size:var(--font-size-md);
}

.contents > .chapter > ul > li.all {
  display:none;
}

.contents > .chapter > ul > li:last-child {
  border-right:none;
}

.footer { 
  position:fixed;
  left:0;
  bottom:0;
  width:100%;
  height:fit-content;
  max-height:70px;
  padding-bottom:50px;
  box-sizing: border-box;
  background-color: var(--color-background);
  box-shadow: 0 -2px 4px var(--tranditanl-color-light);
  border-radius: 24px 24px 0 0;
  transition: all 0.2s ease-in-out;
}

.footer.closed {
  left:0;
  bottom:0;
}

.footer.open {
  left:0;
  bottom:0;
  height:fit-content;
  max-height: 500px; /* 예상 최대치보다 충분히 크게 설정 */
}

.footer > .open_btn {
  width:100%;
  height:24px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

.footer > .open_btn > span {
  width:40px;
  height:4px;
  background-color: var(--color-text-primary);
  border-radius:2px;
  transition: all 0.2s ease-in-out;
}

.footer > .footer-content {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  padding:16px;
  box-sizing: border-box;
}

.footer > .short {
  width:100%;
  height:36px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  padding:0px 16px;
  box-sizing: border-box;
}

.footer > .short > ul {
  width:fit-content;
  height:100%;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:12px;
  padding:0;
  margin:0;
}

.footer > .short > ul > li {
  width:fit-content;
  height:100%;
  display:flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-md);
  gap:6px;
}

.footer > .short > ul > li > span {
  font-size:var(--font-size-md);
  color: var(--color-text-primary);
}

.footer > .short > ul > li > h2 {
  font-size:var(--font-size-lg);
  color: var(--color-text-primary);
  padding:0;
  margin:0;
}

.footer > ul {
  width:100%;
  height:fit-content;
  display:flex;
  padding: 16px;
  box-sizing: border-box;
  list-style: none;
  margin:0;
}

.footer > ul > li {
  width:100%;
  display:flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  font-size: var(--font-size-md);
  cursor:pointer;
  gap:6px;
  border-right: 1px solid var(--tranditanl-color-light);
  padding:0px 12px;
  box-sizing: border-box;
}

.footer > ul > li:last-child {
  border-right:none;
}

.footer > ul > li > .dual-stack {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  align-items: center;
}

.footer > ul > li > .dual-stack > div {
  width:100%;
  height:100%;
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-base);
}

.footer > ul > li > .other {
  width:100%;
  height:100%;
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-base);
}

.footer > .last {
  position:absolute;
  bottom:0px;
  width:100%;
  height:48px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  padding:0px 16px;
  box-sizing: border-box;
  background:var(--color-background);
}

.footer > .last > span {
  width:100%;
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
}

.footer > .last > button {
  width:120px;
  height:36px;
  background:var(--color-brand);
  color: var(--color-text-primary);
  border:none;
  border-radius:6px;
  font-size: var(--font-size-base);
  cursor:pointer;
}


.main-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  color: var(--color-text-primary);
  padding: 16px;
  box-sizing: border-box;
}

.main-header > p {
  aspect-ratio: 1/1;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--color-text-primary);
  font-size: var(--font-size-xl);
  cursor: pointer;
  margin:0;
  padding:0;
}

.main-header > div {
  display: flex;
  align-items: center;
  gap:12px;
}

.main-header img {
  width: 36px;
  height: 36px;
}

.main-header h2 {
  font-size: var(--font-size-xl);
  color: var(--color-text-primary);
  margin:0;
  padding:0;
}

.alert {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.alert > .paper {
  width: fit-content;
  max-width: 600px;
  min-width: 400px;
  height: fit-content;
  background: var(--tranditanl-color);
  border-radius: 16px;
  padding: 24px 16px;
  box-sizing: border-box;
  gap:16px;
  display:flex;
  flex-direction: column;
  align-items: center;
}

.alert > .paper > h2 {
  width:100%;
  text-align: start;
  font-size: var(--font-size-lg);
  font-weight:600;
  margin:0;
  padding:0;
}

.alert > .paper > p {
  width:100%;
  text-align: start;
  font-size: var(--font-size-base);
  color:var(--color-text-secondary);
  font-weight:600;
  margin:0;
  margin-bottom:24px;
  padding:0;
}

.alert > .cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.alert > .paper > .btns {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:12px;
}

.alert > .paper > .btns > button {
  width:100%;
  height:36px;
  background: var(--color-brand);
  color: var(--color-text-black);
  border-radius:6px;
  border:none;
  font-size:var(--font-size-md);
  font-weight:600;
  cursor:pointer;
}

.alert > .paper > .btns > button.cancel {
  background: var(--tranditanl-color-light);
  color: var(--color-text-primary);
}

#etc-notice-sp {
  display: none;
  font-size: var(--font-size-md);
}

/* 피드백 버튼 */
.btn_feedback {
  gap: 6px;
}

.btn_feedback.requested {
  opacity: 0.6;
  cursor: not-allowed;
  border-color: #f59e0b !important;
  color: #f59e0b;
}

.btn_feedback.complete {
  border-color: #22c55e !important;
  color: #22c55e;
}

/* 피드백 이력 다이얼로그 */
.feedback-history {
  max-width: 500px;
}

.feedback-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
  padding: 12px 0;
}

.feedback-item {
  padding: 16px;
  background: var(--tranditanl-color);
  border: 2px solid var(--color-surface-reverse);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feedback-item.complete {
  border-color: #22c55e;
}

.feedback-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.feedback-meta .status {
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.feedback-meta .status.requested {
  background: #f59e0b;
  color: white;
}

.feedback-meta .status.complete {
  background: #22c55e;
  color: white;
}

.feedback-meta .date {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.feedback-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feedback-content .reviewer {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  margin: 0;
}

.feedback-content .comment {
  font-size: var(--font-size-base);
  margin: 0;
  padding: 12px;
  background: var(--color-background);
  white-space: pre-wrap;
}

.feedback-content .view-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: var(--color-text-primary);
  color: var(--color-background);
  border: none;
  font-size: var(--font-size-sm);
  font-weight: 600;
  cursor: pointer;
}

.feedback-history .btns {
  padding-top: 12px;
  border-top: 1px solid var(--color-surface-reverse);
}

.feedback-history .request-btn {
  width: 100%;
  padding: 12px;
  background: var(--color-brand);
  color: var(--color-text-black);
  border: none;
  font-size: var(--font-size-base);
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.empty {
  text-align: center;
  padding: 40px;
  color: var(--color-text-secondary);
}

/* ========================================
   엑셀 테이블 (표형 인쇄)
======================================== */
.excel-table {
  display: none;
  width: 100%;
  background: white;
  color: #000;
}

.excel-header {
  margin-bottom: 8px;
}

.excel-title h1 {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin: 0 0 8px 0;
  padding: 0;
  text-decoration: underline;
}

.excel-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding: 0 4px;
}

.excel-info strong {
  font-weight: bold;
}

.excel-info .unit {
  color: #666;
}

.excel-unified-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  table-layout: fixed;
}

.excel-unified-table th,
.excel-unified-table td {
  border: 1px solid #333;
  padding: 4px 6px;
  text-align: center;
  vertical-align: middle;
  word-break: keep-all;
}

.excel-unified-table thead th {
  background-color: var(--tranditanl-color) !important;
  font-weight: bold;
  font-size: 10px;
  padding: 4px;
}

.excel-unified-table th small {
  display: block;
  font-weight: normal;
  font-size: 8px;
  color: #666;
  margin-top: 2px;
}

.header-sub th {
  font-size: 9px;
  padding: 3px 4px;
}

.col-plan { width: 6%; }
.col-narrow { width: 9%; }
.col-coverage { width: 10%; }
.col-sub { width: 5%; }

.plan-cell {
  background-color: #f8f8f8 !important;
  vertical-align: middle !important;
  padding: 6px !important;
}

.plan-info-compact {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
  line-height: 1.4;
}

.plan-info-compact strong { font-size: 13px; font-weight: bold; }
.plan-info-compact span { font-size: 11px; color: #333; }
.plan-info-compact small { font-size: 10px; color: #666; }
.plan-info-compact em { font-size: 11px; font-style: normal; font-weight: bold; color: #000; }

.cell-stack {
  line-height: 1.5;
  font-size: 12px;
  text-align: left;
  padding: 4px 6px;
}

.cell-stack .bold { font-weight: 900; text-decoration: underline; }
.cell-stack .important { color: #888; }

.excel-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  font-size: 11px;
  color: #666;
}

/* ========================================
   프린트 미디어 쿼리 - 엑셀형
======================================== */
@media print {
  /* 표형 인쇄 모드 */
  #module-CA-detail.print-excel .chart,
  #module-CA-detail.print-excel .contents,
  #module-CA-detail.print-excel #etc-notice-sp,
  #module-CA-detail.print-excel .main-header,
  #module-CA-detail.print-excel .header,
  #module-CA-detail.print-excel .footer,
  #module-CA-detail.print-excel .dialog,
  #module-CA-detail.print-excel .alert,
  #module-CA-detail.print-excel .system {
    display: none !important;
  }

  #module-CA-detail.print-excel {
    position: absolute !important;
    left: 0;
    top: 0;
    z-index: 999999999;
    height: 100vh !important;
    overflow: visible !important;
    padding: 4px 8px !important;
    background: white !important;
  }

  #module-CA-detail.print-excel .excel-table {
    display: block !important;
    width: 100%;
    overflow: visible !important;
    position: static !important;
  }

  #module-CA-detail.print-excel .excel-header {
    margin-bottom: 4px;
  }

  #module-CA-detail.print-excel .excel-title h1 {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin: 0 0 4px 0;
    padding: 0;
    text-decoration: underline;
  }

  #module-CA-detail.print-excel .excel-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    padding: 0 2px;
  }

  #module-CA-detail.print-excel .excel-info strong {
    font-weight: bold;
  }

  #module-CA-detail.print-excel .excel-info .unit {
    color: #666;
  }

  #module-CA-detail.print-excel .excel-unified-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 10px;
    table-layout: fixed;
    page-break-inside: auto;
  }

  #module-CA-detail.print-excel .excel-unified-table th,
  #module-CA-detail.print-excel .excel-unified-table td {
    border: 1px solid #333;
    padding: 3px 4px;
    text-align: center;
    vertical-align: middle;
    word-break: keep-all;
  }

  #module-CA-detail.print-excel .excel-unified-table thead {
    display: table-header-group;
  }

  #module-CA-detail.print-excel .excel-unified-table thead th {
    background-color: var(--tranditanl-color) !important;
    font-weight: bold;
    font-size: 9px;
    padding: 2px 3px;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  #module-CA-detail.print-excel .excel-unified-table th small {
    display: block;
    font-weight: normal;
    font-size: 7px;
    color: #666;
    margin-top: 1px;
  }

  #module-CA-detail.print-excel .header-sub th {
    font-size: 8px;
    padding: 2px 3px;
  }

  #module-CA-detail.print-excel .col-plan { width: 5%; }
  #module-CA-detail.print-excel .col-narrow { width: 8%; }
  #module-CA-detail.print-excel .col-coverage { width: 10%; }
  #module-CA-detail.print-excel .col-sub { width: 4%; }

  #module-CA-detail.print-excel .plan-cell {
    background-color: #f8f8f8 !important;
    vertical-align: middle !important;
    padding: 4px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  #module-CA-detail.print-excel .plan-info-compact {
    display: flex;
    flex-direction: column;
    gap: 1px;
    text-align: left;
    line-height: 1.3;
  }

  #module-CA-detail.print-excel .plan-info-compact strong { font-size: 12px; font-weight: bold; }
  #module-CA-detail.print-excel .plan-info-compact span { font-size: 10px; color: #333; }
  #module-CA-detail.print-excel .plan-info-compact small { font-size: 10px; color: #666; }
  #module-CA-detail.print-excel .plan-info-compact em { font-size: 10px; font-style: normal; font-weight: bold; color: #000; }

  #module-CA-detail.print-excel .cell-stack {
    line-height: 1.4;
    font-size: 11px;
    text-align: left;
    padding: 3px 4px;
  }

  #module-CA-detail.print-excel .cell-stack .bold { font-weight: 900; text-decoration: underline; }
  #module-CA-detail.print-excel .cell-stack .important { color: #888; }

  #module-CA-detail.print-excel .excel-unified-table tbody tr { break-inside: avoid; page-break-inside: avoid; }
  #module-CA-detail.print-excel .excel-unified-table tbody td { vertical-align: top; padding: 4px 5px; }

  #module-CA-detail.print-excel .excel-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    font-size: 10px;
    color: #666;
  }
}

/* ========================================
   인쇄 드롭다운 메뉴
======================================== */
.print-dropdown-wrap {
  position: relative;
  display: inline-block;
  padding:0 !important;
  border:none !important;
}

.print-dropdown-wrap > button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
  height: 100%;
  padding: 0 24px;
  background: none;
  border: 1px solid var(--tranditanl-color-light);
  color: var(--color-text-primary);
  border-radius: 6px;
  font-size: var(--font-size-md);
  font-weight: 600;
  cursor: pointer;
  gap: 6px;
}

.print-dropdown-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

.print-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  z-index: 100;
  min-width: 150px;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  animation: printDropIn 0.15s ease-out;
}

.print-dropdown::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
}

.print-dropdown button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  transition: background 0.15s;
}

.print-dropdown button:hover {
  background: #f3f4f6;
}

.print-dropdown button i {
  font-size: 18px;
  color: #666;
}

@keyframes printDropIn {
  from { opacity: 0; transform: translateX(-50%) translateY(-4px); }
  to { opacity: 1; transform: translateX(-50%) translateY(0); }
}

@media print {
  .print-dropdown-wrap .print-dropdown,
  .print-dropdown-wrap .print-dropdown-backdrop {
    display: none !important;
  }
}
</style>